import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: string; output: string };
  Long: { input: any; output: any };
  Url: { input: string; output: string };
};

export type AccessCodePolicy = {
  __typename?: 'AccessCodePolicy';
  /** Access code */
  accessCode: Scalars['String']['output'];
  /** Determines if the policy is active or not */
  enabled: Scalars['Boolean']['output'];
};

export type AddSpeakerInput = {
  /** Speaker full name */
  name: Scalars['String']['input'];
  /** Asset ID of the previously uploaded speaker picture */
  pictureAssetId: Scalars['ID']['input'];
  /** Speaker position / job title */
  position: Scalars['String']['input'];
  /** Webcast to add the speaker to */
  webcastId: Scalars['ID']['input'];
};

export type AddSpeakerProblem = {
  __typename?: 'AddSpeakerProblem';
  code: AddSpeakerProblemCode;
};

export enum AddSpeakerProblemCode {
  /** Maximum number of speakers (6) reached */
  MAX_SPEAKERS_REACHED = 'MAX_SPEAKERS_REACHED',
  /** Picture asset already used by another speaker in the same webcast */
  PICTURE_ALREADY_IN_USE = 'PICTURE_ALREADY_IN_USE',
  /** Picture asset not found */
  PICTURE_NOT_FOUND = 'PICTURE_NOT_FOUND',
  /** Picture asset not yet uploaded */
  PICTURE_NOT_UPLOADED = 'PICTURE_NOT_UPLOADED',
  /** Webcast not found */
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type AddSpeakerResult = AddSpeakerProblem | AddSpeakerSuccess;

export type AddSpeakerSuccess = {
  __typename?: 'AddSpeakerSuccess';
  speaker: Speaker;
};

export type AddUsersInput = {
  users: Array<Scalars['String']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type AiLiveTranscriptEditor = {
  __typename?: 'AiLiveTranscriptEditor';
  accessPin: Scalars['String']['output'];
  editorUrl: Scalars['String']['output'];
};

export type AiLiveTranscriptEditorSettings = {
  __typename?: 'AiLiveTranscriptEditorSettings';
  backup?: Maybe<AiLiveTranscriptEditor>;
  primary?: Maybe<AiLiveTranscriptEditor>;
};

export type AiSubtitlesFeature = LiveStreamProFeature & {
  __typename?: 'AiSubtitlesFeature';
  enabled: Scalars['Boolean']['output'];
};

/** Webcast Analytics */
export type Analytics = {
  __typename?: 'Analytics';
  /** NPAW: A count of plays which are still consuming video at the end of the minute selected. Use during LIVE */
  activePlays?: Maybe<Scalars['Int']['output']>;
  /** NPAW: A count of plays which are still consuming video at the end of the minute selected. Use during LIVE */
  activePlaysStats: MetricStats;
  /** NPAW: An average of the playtime associated with each unique user for the time range selected */
  avgPlaytime?: Maybe<Scalars['Float']['output']>;
  /**
   * NPAW: Reports the amount of views in which at least one frame of the video is reproduced
   * @deprecated Use activePlays instead for LIVE state and peakActivePlays for POSTLIVE state
   */
  concurrentPlays?: Maybe<Scalars['Int']['output']>;
  /**
   * Minute-by-minute metrics timeline for the webcast.
   * Available only in POSTLIVE state; returns null otherwise.
   */
  eventTimeline?: Maybe<EventTimeline>;
  /** Highest number of active plays that webcast had in LIVE state. Available only in POSTLIVE, otherwise 0 */
  peakActivePlays?: Maybe<Scalars['Int']['output']>;
  /** NPAW: Play attempts regardless of whether the playback carried on */
  plays?: Maybe<Scalars['Int']['output']>;
  /** NPAW: Number of users who were consuming content */
  uniqueUsers?: Maybe<Scalars['Int']['output']>;
  /** Webcast ID */
  webcastId: Scalars['ID']['output'];
};

export type AnonymousChatSettings = ChatSettings & {
  __typename?: 'AnonymousChatSettings';
  allowBeforeLive: Scalars['Boolean']['output'];
  type: ChatType;
};

export type AppearanceAsset = {
  __typename?: 'AppearanceAsset';
  downloadLink?: Maybe<Scalars['String']['output']>;
  type: AppearanceAssetType;
  uploadLink: UploadLink;
};

export enum AppearanceAssetType {
  FAVICON = 'FAVICON',
  HORIZONTAL_LOGO = 'HORIZONTAL_LOGO',
  LOGO = 'LOGO',
}

/** Requires valid hex color code (e.g. #000 or #000000) */
export type AppearanceColors = {
  __typename?: 'AppearanceColors';
  backgroundColor: Scalars['String']['output'];
  cardColor: Scalars['String']['output'];
  headingFontColor: Scalars['String']['output'];
  iconColor: Scalars['String']['output'];
  primaryColor: Scalars['String']['output'];
  textFontColor: Scalars['String']['output'];
  theme: Theme;
};

export type AppearanceColorsInput = {
  backgroundColor: Scalars['String']['input'];
  cardColor: Scalars['String']['input'];
  headingFontColor: Scalars['String']['input'];
  iconColor?: InputMaybe<Scalars['String']['input']>;
  primaryColor: Scalars['String']['input'];
  textFontColor: Scalars['String']['input'];
  theme: Theme;
};

export type AppearanceFonts = {
  __typename?: 'AppearanceFonts';
  headingFont: Scalars['ID']['output'];
  textFont: Scalars['ID']['output'];
};

export type AppearanceFontsInput = {
  headingFont: Scalars['ID']['input'];
  textFont: Scalars['ID']['input'];
};

export type AppearanceSettings = {
  __typename?: 'AppearanceSettings';
  appearanceColors: Array<AppearanceColors>;
  assets: Array<AppearanceAsset>;
  fonts: AppearanceFonts;
  /**
   * Requires valid hex color code (e.g. #000 or #000000)
   * @deprecated Use appearanceColors instead
   */
  primaryColor: Scalars['String']['output'];
  supportedFonts: Array<Font>;
  theme: Theme;
};

export type AppearanceTheme = {
  __typename?: 'AppearanceTheme';
  /** Color scheme settings */
  appearanceColors: Array<AppearanceColors>;
  assets: Array<AppearanceAsset>;
  fonts: AppearanceFonts;
  /** ID of the theme */
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  mode: Theme;
  /** Name of the theme */
  name: Scalars['String']['output'];
};

export type ArchiveWebcastProblem = {
  __typename?: 'ArchiveWebcastProblem';
  /** Code indicating the problem */
  code: ArchiveWebcastProblemCode;
};

export enum ArchiveWebcastProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type ArchiveWebcastResult = ArchiveWebcastProblem | ArchiveWebcastSuccess;

export type ArchiveWebcastSuccess = {
  __typename?: 'ArchiveWebcastSuccess';
  webcast: Webcast;
};

export type Asset = {
  __typename?: 'Asset';
  assetId: Scalars['ID']['output'];
  downloadLink?: Maybe<Scalars['Url']['output']>;
  status: AssetUploadStatus;
};

export type AssetCreateResult = AssetCreateResultFailure | AssetCreateResultSuccess;

export type AssetCreateResultFailure = {
  __typename?: 'AssetCreateResultFailure';
  code: AssetCreateResultFailureCode;
};

export enum AssetCreateResultFailureCode {
  ALREADY_UPLOADED = 'ALREADY_UPLOADED',
  ENTITY_NOT_FOUND = 'ENTITY_NOT_FOUND',
  LANGUAGE_NOT_CONFIGURED = 'LANGUAGE_NOT_CONFIGURED',
  LANGUAGE_NOT_SUPPORTED = 'LANGUAGE_NOT_SUPPORTED',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type AssetCreateResultSuccess = {
  __typename?: 'AssetCreateResultSuccess';
  assetId: Scalars['ID']['output'];
  uploadLink: UploadLink;
};

export type AssetDeleteResult = {
  __typename?: 'AssetDeleteResult';
  assetId?: Maybe<Scalars['ID']['output']>;
};

export enum AssetUploadErrorCode {
  SERVER_ERROR = 'SERVER_ERROR',
}

export type AssetUploadStatus = {
  __typename?: 'AssetUploadStatus';
  code: AssetUploadStatusCode;
  error?: Maybe<AssetUploadErrorCode>;
};

export enum AssetUploadStatusCode {
  FAILED = 'FAILED',
  PENDING = 'PENDING',
  UPLOADED = 'UPLOADED',
}

export type AudienceRange = {
  __typename?: 'AudienceRange';
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
};

export type AudienceRangeInput = {
  max: Scalars['Int']['input'];
  min: Scalars['Int']['input'];
};

export type BlaStreamRoom = {
  __typename?: 'BlaStreamRoom';
  connectionInfo?: Maybe<BlaStreamRoomConnectionInfo>;
  creationForbiddenCause?: Maybe<CreationForbiddenCause>;
  isCreationPermitted: Scalars['Boolean']['output'];
  webcastId: Scalars['ID']['output'];
};

export type BlaStreamRoomConnectionInfo = {
  __typename?: 'BlaStreamRoomConnectionInfo';
  link: Scalars['Url']['output'];
};

export type BlaStreamSimulcast = {
  __typename?: 'BlaStreamSimulcast';
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  serverUrl: Scalars['String']['output'];
  streamKey: Scalars['String']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type BrowserBasedStudioFeature = LiveStreamProFeature & {
  __typename?: 'BrowserBasedStudioFeature';
  enabled: Scalars['Boolean']['output'];
};

export type Channel = {
  __typename?: 'Channel';
  children: Array<Maybe<Scalars['ID']['output']>>;
  id: Scalars['ID']['output'];
  isVideoUploadAllowedForUser?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
};

/** Chat configuration */
export type Chat = {
  __typename?: 'Chat';
  apiHost: Scalars['String']['output'];
  applicationId: Scalars['String']['output'];
  channelUrl: Scalars['String']['output'];
  isFrozen: Scalars['Boolean']['output'];
  moderatorIds: Array<Maybe<Scalars['String']['output']>>;
  settings: ChatSettings;
  wsHost: Scalars['String']['output'];
};

export type ChatSettings = {
  allowBeforeLive: Scalars['Boolean']['output'];
  /** Type of chat. This data is duplicated by '__typename', but the field still may be useful. */
  type: ChatType;
};

export enum ChatType {
  ANONYMOUS = 'ANONYMOUS',
  MODERATED = 'MODERATED',
  UNMODERATED = 'UNMODERATED',
}

export type ClearVodChaptersThumbnailsInput = {
  ids: Array<Scalars['ID']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type ClearVodChaptersThumbnailsProblem = {
  __typename?: 'ClearVodChaptersThumbnailsProblem';
  code: ClearVodChaptersThumbnailsProblemCode;
};

export type ClearVodChaptersThumbnailsProblemChaptersNotFound = {
  __typename?: 'ClearVodChaptersThumbnailsProblemChaptersNotFound';
  invalidIds: Array<Scalars['ID']['output']>;
};

export enum ClearVodChaptersThumbnailsProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type ClearVodChaptersThumbnailsResult =
  | ClearVodChaptersThumbnailsProblem
  | ClearVodChaptersThumbnailsProblemChaptersNotFound
  | ClearVodChaptersThumbnailsSuccess;

export type ClearVodChaptersThumbnailsSuccess = {
  __typename?: 'ClearVodChaptersThumbnailsSuccess';
  chapters: Array<VodChapter>;
};

export type ComplianceForm = {
  __typename?: 'ComplianceForm';
  entries: Array<LocalizedComplianceFormEntry>;
  /** @deprecated Use localized compliance form entries instead */
  text?: Maybe<Scalars['String']['output']>;
};

export type ComplianceFormInput = {
  text: Scalars['String']['input'];
};

export type ComplianceSettingsFormInput = {
  entries: Array<LocalizedComplianceSettingsEntryInput>;
};

export type Configuration = {
  __typename?: 'Configuration';
  appearanceColors: Array<AppearanceColors>;
  defaultComplianceForm: ComplianceForm;
  supportedFonts: Array<Scalars['ID']['output']>;
  supportedLanguages: Array<Scalars['String']['output']>;
  supportedSubtitleLanguages: Array<Scalars['String']['output']>;
  transcodingProfile: TranscodingProfile;
};

export type CreateAppearanceAssetFailure = {
  __typename?: 'CreateAppearanceAssetFailure';
  code: CreateAppearanceAssetFailureCode;
};

export enum CreateAppearanceAssetFailureCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  THEME_NOT_FOUND = 'THEME_NOT_FOUND',
}

export type CreateAppearanceAssetInput = {
  assetType: AppearanceAssetType;
  lsproId: Scalars['String']['input'];
  themeId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateAppearanceAssetResult = CreateAppearanceAssetFailure | CreateAppearanceAssetSuccess;

export type CreateAppearanceAssetSuccess = {
  __typename?: 'CreateAppearanceAssetSuccess';
  asset: AppearanceAsset;
};

export type CreateChatInput = {
  /** Indicates whether chat users can use chat before the event goes to LIVE state. */
  allowBeforeLive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ids of Users that are granted chat moderation rights */
  moderatorIds?: InputMaybe<Array<Scalars['String']['input']>>;
  type: ChatType;
  /** Indicates whether chat users should have username provided by SSO or their email. True by default */
  useProvidedUsername?: InputMaybe<Scalars['Boolean']['input']>;
  webcastId: Scalars['ID']['input'];
};

/** Create Webcast chat has failed */
export type CreateChatProblem = {
  __typename?: 'CreateChatProblem';
  /** Code indicating the problem */
  code: CreateChatProblemCode;
};

export enum CreateChatProblemCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type CreateChatResult = CreateChatProblem | CreateChatSuccess;

/** Create Webcast chat has succeeded */
export type CreateChatSuccess = {
  __typename?: 'CreateChatSuccess';
  channelUrl: Scalars['String']['output'];
  chatProviderAccountId: Scalars['String']['output'];
};

export type CreateChatUsersProblem = {
  __typename?: 'CreateChatUsersProblem';
  /** Code indicating the problem */
  code: CreateChatUsersProblemCode;
};

export enum CreateChatUsersProblemCode {
  CHAT_ACCOUNT_NOT_INITIALIZED = 'CHAT_ACCOUNT_NOT_INITIALIZED',
  LSPRO_USERS_NOT_FOUND = 'LSPRO_USERS_NOT_FOUND',
}

export type CreateChatUsersResult = CreateChatUsersProblem | CreateChatUsersSuccess;

/** Chat users created */
export type CreateChatUsersSuccess = {
  __typename?: 'CreateChatUsersSuccess';
  userIds: Array<Scalars['String']['output']>;
};

export type CreateFontInput = {
  /** ID of LSPro instance this font will be visible in */
  lsproId: Scalars['ID']['input'];
  /** Display name of custom font */
  name: Scalars['String']['input'];
};

export type CreateFontProblem = {
  __typename?: 'CreateFontProblem';
  code: CreateFontProblemCode;
};

export enum CreateFontProblemCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type CreateFontResult = CreateFontProblem | CreateFontSuccess;

export type CreateFontSuccess = {
  __typename?: 'CreateFontSuccess';
  fontId: Scalars['ID']['output'];
  uploadLink: UploadLink;
};

export type CreateLiveStreamProInput = {
  accountId: Scalars['String']['input'];
  features?: InputMaybe<Array<UpdateLiveStreamProFeatureInput>>;
  name: Scalars['String']['input'];
};

export type CreatePictureInput = {
  type: PictureType;
  /** Webcast the picture belongs to */
  webcastId: Scalars['ID']['input'];
};

export type CreatePictureProblem = {
  __typename?: 'CreatePictureProblem';
  code: CreatePictureProblemCode;
};

export enum CreatePictureProblemCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type CreatePictureResult = CreatePictureProblem | CreatePictureSuccess;

export type CreatePictureSuccess = {
  __typename?: 'CreatePictureSuccess';
  assetId: Scalars['ID']['output'];
  uploadLink: UploadLink;
};

export type CreatePresentationInput = {
  /** Language (ISO 639-1 code) */
  language: Scalars['String']['input'];
  /** Original name of presentation file */
  sourceFileName: Scalars['String']['input'];
  /** Webcast ID given presentation will be associated with */
  webcastId: Scalars['ID']['input'];
};

export type CreatePresentationProblem = {
  __typename?: 'CreatePresentationProblem';
  /** Code indicating the problem */
  code: CreatePresentationProblemCode;
};

export enum CreatePresentationProblemCode {
  ALREADY_EXISTS = 'ALREADY_EXISTS',
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  GROUP_ID_NOT_FOUND = 'GROUP_ID_NOT_FOUND',
  LANGUAGE_NOT_CONFIGURED = 'LANGUAGE_NOT_CONFIGURED',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  /** @deprecated Use FORBIDDEN_FOR_CURRENT_WEBCAST_STATE */
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type CreatePresentationResult = CreatePresentationProblem | CreatePresentationSuccess | ValidationErrors;

/** Presentation has been successfully created */
export type CreatePresentationSuccess = {
  __typename?: 'CreatePresentationSuccess';
  /** Created presentation */
  presentation: Presentation;
};

export type CreateThemeFailure = {
  __typename?: 'CreateThemeFailure';
  code: CreateThemeFailureCode;
};

export enum CreateThemeFailureCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  THEME_NAME_ALREADY_EXISTS = 'THEME_NAME_ALREADY_EXISTS',
}

export type CreateThemeInput = {
  /** ID of LSPro instance */
  lsproId: Scalars['ID']['input'];
  /** Name of the theme */
  name: Scalars['String']['input'];
};

export type CreateThemeResult = CreateThemeFailure | CreateThemeSuccess;

export type CreateThemeSuccess = {
  __typename?: 'CreateThemeSuccess';
  theme: AppearanceTheme;
};

export type CreateWebcastInput = {
  /** When true, the webcast is audio only (no video). Defaults to false. */
  audioOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Planned duration of the webcast event in minutes. Set to 0 if planned duration is not known */
  durationInMinutes: Scalars['Int']['input'];
  /** When true, the event planned start time and duration are not displayed for viewers */
  hideWebcastScheduleInViewer?: Scalars['Boolean']['input'];
  /** Type of protocol for ingestion */
  ingestProtocol?: InputMaybe<IngestProtocol>;
  /** LiveStream Pro id */
  lsproId: Scalars['String']['input'];
  /** Webcast event name and initial title for primary language */
  name: Scalars['String']['input'];
  /** Planned start date and time (ISO 8601) */
  plannedStartAt: Scalars['DateTime']['input'];
  /**
   * Theme for the event
   * Set to null to use default theme configured for lspro
   */
  themeId?: InputMaybe<Scalars['String']['input']>;
};

/** Webcast creation failed */
export type CreateWebcastProblem = {
  __typename?: 'CreateWebcastProblem';
  /** Code indicating the problem */
  code: CreateWebcastProblemCode;
};

export enum CreateWebcastProblemCode {
  THEME_NOT_FOUND = 'THEME_NOT_FOUND',
}

export type CreateWebcastResult = CreateWebcastProblem | CreateWebcastSuccess | ValidationErrors;

/** Webcast has been successfully created */
export type CreateWebcastSuccess = {
  __typename?: 'CreateWebcastSuccess';
  webcast: Webcast;
};

export enum CreationForbiddenCause {
  LSPRO_FEATURE_NOT_ENABLED = 'LSPRO_FEATURE_NOT_ENABLED',
  WEBCAST_IS_MULTILANG = 'WEBCAST_IS_MULTILANG',
  WEBCAST_IS_NOT_INITIALISED = 'WEBCAST_IS_NOT_INITIALISED',
  WEBCAST_IS_SRT = 'WEBCAST_IS_SRT',
}

export type CurrentUser = {
  __typename?: 'CurrentUser';
  accounts: Array<CurrentUserAccount>;
  id: Scalars['ID']['output'];
  isVmproLinked: Scalars['Boolean']['output'];
};

export type CurrentUserAccount = {
  __typename?: 'CurrentUserAccount';
  liveStreamPro: LiveStreamPro;
  userRoles: Array<Role>;
};

export type CustomDomains = {
  __typename?: 'CustomDomains';
  assetOutBaseUrl?: Maybe<Scalars['String']['output']>;
  backupPlaybackBaseUrl?: Maybe<Scalars['String']['output']>;
  chatApiUrl?: Maybe<Scalars['String']['output']>;
  chatWsUrl?: Maybe<Scalars['String']['output']>;
  playoutBaseUrl?: Maybe<Scalars['String']['output']>;
  primaryPlaybackBaseUrl?: Maybe<Scalars['String']['output']>;
  viewerBaseUrl?: Maybe<Scalars['String']['output']>;
};

export type CustomDomainsFeature = LiveStreamProFeature & {
  __typename?: 'CustomDomainsFeature';
  customDomains: CustomDomains;
  enabled: Scalars['Boolean']['output'];
};

export type CustomDomainsInput = {
  assetOutBaseUrl?: InputMaybe<Scalars['String']['input']>;
  backupPlaybackBaseUrl?: InputMaybe<Scalars['String']['input']>;
  chatApiUrl?: InputMaybe<Scalars['String']['input']>;
  chatWsUrl?: InputMaybe<Scalars['String']['input']>;
  playoutBaseUrl?: InputMaybe<Scalars['String']['input']>;
  primaryPlaybackBaseUrl?: InputMaybe<Scalars['String']['input']>;
  viewerBaseUrl?: InputMaybe<Scalars['String']['input']>;
};

export type CustomFontInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type CustomLanguage = {
  __typename?: 'CustomLanguage';
  code: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CustomVodManifestUrlFeature = LiveStreamProFeature & {
  __typename?: 'CustomVodManifestUrlFeature';
  enabled: Scalars['Boolean']['output'];
};

export type DataProtectionForm = {
  __typename?: 'DataProtectionForm';
  entries: Array<LocalizedDataProtectionEntry>;
};

export type DateRange = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Default ingest settings configured at LSPro level, applied when creating new webcasts.
 * Either DefaultSrtIngestSettings or DefaultRtmpIngestSettings.
 */
export type DefaultIngestSettings = DefaultRtmpIngestSettings | DefaultSrtIngestSettings;

/**
 * Input for configuring default ingest settings at LSPro level.
 * Provide exactly one of srt or rtmp. If both are provided, an error is returned.
 */
export type DefaultIngestSettingsInput = {
  rtmp?: InputMaybe<DefaultRtmpIngestSettingsInput>;
  srt?: InputMaybe<DefaultSrtIngestSettingsInput>;
};

/** Default ingest settings for RTMP protocol */
export type DefaultRtmpIngestSettings = {
  __typename?: 'DefaultRtmpIngestSettings';
  /** Whether RTMP ingest authentication is enabled by default for new webcasts */
  authenticationEnabled: Scalars['Boolean']['output'];
};

/** Input for RTMP default ingest settings */
export type DefaultRtmpIngestSettingsInput = {
  /** Whether RTMP ingest authentication is enabled by default for new webcasts */
  authenticationEnabled?: Scalars['Boolean']['input'];
};

/** Default ingest settings for SRT protocol */
export type DefaultSrtIngestSettings = {
  __typename?: 'DefaultSrtIngestSettings';
  /** Placeholder field (GraphQL requires at least one field per type) */
  _?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for SRT default ingest settings (no additional parameters needed) */
export type DefaultSrtIngestSettingsInput = {
  /** Placeholder field (GraphQL requires at least one field per input) */
  _?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeleteAppearanceAssetFailure = {
  __typename?: 'DeleteAppearanceAssetFailure';
  code?: Maybe<DeleteAppearanceAssetFailureCode>;
};

export enum DeleteAppearanceAssetFailureCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  THEME_NOT_FOUND = 'THEME_NOT_FOUND',
}

export type DeleteAppearanceAssetInput = {
  assetType: AppearanceAssetType;
  lsproId: Scalars['String']['input'];
  themeId?: InputMaybe<Scalars['ID']['input']>;
};

export type DeleteAppearanceAssetResult = DeleteAppearanceAssetFailure | DeleteAppearanceAssetSuccess;

export type DeleteAppearanceAssetSuccess = {
  __typename?: 'DeleteAppearanceAssetSuccess';
  lsproId: Scalars['String']['output'];
};

/** Delete Webcast chat has failed */
export type DeleteChatProblem = {
  __typename?: 'DeleteChatProblem';
  /** Code indicating the problem */
  code: DeleteChatProblemCode;
};

export enum DeleteChatProblemCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type DeleteChatResult = DeleteChatProblem | DeleteChatSuccess;

/** Delete Webcast chat has succeeded */
export type DeleteChatSuccess = {
  __typename?: 'DeleteChatSuccess';
  webcastId: Scalars['ID']['output'];
};

export type DeleteFontInput = {
  /** ID of the font to be deleted */
  fontId: Scalars['ID']['input'];
  /** ID of LSPro instance */
  lsproId: Scalars['ID']['input'];
};

export type DeleteFontProblem = {
  __typename?: 'DeleteFontProblem';
  code: DeleteFontProblemCode;
};

export enum DeleteFontProblemCode {
  FONT_IN_USE = 'FONT_IN_USE',
  FONT_NOT_FOUND = 'FONT_NOT_FOUND',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type DeleteFontResult = DeleteFontProblem | DeleteFontSuccess;

export type DeleteFontSuccess = {
  __typename?: 'DeleteFontSuccess';
  fontId: Scalars['ID']['output'];
};

export type DeletePresentationInput = {
  /** Presentation group ID */
  groupId: Scalars['ID']['input'];
  /** language (ISO 639-1 code) */
  language: Scalars['String']['input'];
  /** Webcast ID associated with given presentation */
  webcastId: Scalars['ID']['input'];
};

/** Presentation deletion has failed */
export type DeletePresentationProblem = {
  __typename?: 'DeletePresentationProblem';
  /** Code indicating the problem */
  code: DeletePresentationProblemCode;
};

export enum DeletePresentationProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  PRESENTATION_NOT_FOUND = 'PRESENTATION_NOT_FOUND',
  /** Occurs when webcast is in LIVE_TEST/LIVE state and deletion is called on uploaded presentation. */
  PRESENTATION_UPLOAD_NOT_FAILED = 'PRESENTATION_UPLOAD_NOT_FAILED',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  /** @deprecated Use FORBIDDEN_FOR_CURRENT_WEBCAST_STATE */
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type DeletePresentationResult = DeletePresentationProblem | DeletePresentationSuccess;

/** Presentation has been successfully deleted */
export type DeletePresentationSuccess = {
  __typename?: 'DeletePresentationSuccess';
  /** Deleted presentation */
  presentation: Presentation;
};

export type DeleteSpeakerInput = {
  speakerId: Scalars['ID']['input'];
  webcastId: Scalars['ID']['input'];
};

export type DeleteSpeakerProblem = {
  __typename?: 'DeleteSpeakerProblem';
  code: DeleteSpeakerProblemCode;
};

export enum DeleteSpeakerProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  SPEAKER_NOT_FOUND = 'SPEAKER_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type DeleteSpeakerResult = DeleteSpeakerProblem | DeleteSpeakerSuccess;

export type DeleteSpeakerSuccess = {
  __typename?: 'DeleteSpeakerSuccess';
  speakerId: Scalars['ID']['output'];
};

export type DeleteThemeFailure = {
  __typename?: 'DeleteThemeFailure';
  code: DeleteThemeFailureCode;
};

export enum DeleteThemeFailureCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  THEME_IS_DEFAULT = 'THEME_IS_DEFAULT',
  THEME_NOT_FOUND = 'THEME_NOT_FOUND',
}

export type DeleteThemeInput = {
  /** ID of LSPro instance */
  lsproId: Scalars['ID']['input'];
  /** ID of the theme to be deleted */
  themeId: Scalars['ID']['input'];
};

export type DeleteThemeResult = DeleteThemeFailure | DeleteThemeSuccess;

export type DeleteThemeSuccess = {
  __typename?: 'DeleteThemeSuccess';
  themeId: Scalars['ID']['output'];
};

export type DeleteUsersInput = {
  userIds: Array<Scalars['ID']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type DeleteVodChaptersInput = {
  ids: Array<Scalars['ID']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type DeleteVodChaptersProblem = {
  __typename?: 'DeleteVodChaptersProblem';
  code: DeleteVodChaptersProblemCode;
};

export type DeleteVodChaptersProblemChaptersNotFound = {
  __typename?: 'DeleteVodChaptersProblemChaptersNotFound';
  invalidIds: Array<Scalars['ID']['output']>;
};

export enum DeleteVodChaptersProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type DeleteVodChaptersResult =
  | DeleteVodChaptersProblem
  | DeleteVodChaptersProblemChaptersNotFound
  | DeleteVodChaptersSuccess;

export type DeleteVodChaptersSuccess = {
  __typename?: 'DeleteVodChaptersSuccess';
  chapters: Array<VodChapter>;
};

export type DeleteVodSlideMarkersInput = {
  markerIds: Array<Scalars['ID']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type DeleteVodSlideMarkersProblem = {
  __typename?: 'DeleteVodSlideMarkersProblem';
  code: DeleteVodSlideMarkersProblemCode;
};

export enum DeleteVodSlideMarkersProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  MARKER_NOT_FOUND = 'MARKER_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type DeleteVodSlideMarkersResult = DeleteVodSlideMarkersProblem | DeleteVodSlideMarkersSuccess;

export type DeleteVodSlideMarkersSuccess = {
  __typename?: 'DeleteVodSlideMarkersSuccess';
  markers: Array<VodSlideMarker>;
};

/** Webcast delete failed */
export type DeleteWebcastProblem = {
  __typename?: 'DeleteWebcastProblem';
  /** Code indicating the problem */
  code: DeleteWebcastProblemCode;
};

export enum DeleteWebcastProblemCode {
  WEBCAST_IN_LIVE_STATE = 'WEBCAST_IN_LIVE_STATE',
}

export type DeleteWebcastResult = DeleteWebcastProblem | DeleteWebcastSuccess;

/** Webcast has been successfully deleted */
export type DeleteWebcastSuccess = {
  __typename?: 'DeleteWebcastSuccess';
  webcast: Webcast;
};

export type DummyData = {
  __typename?: 'DummyData';
  /** List of lspro IDs */
  lsproIds: Array<Scalars['ID']['output']>;
  /** List of webcast IDs */
  webcastIds: Array<Scalars['ID']['output']>;
};

export type DuplicateWebcastInput = {
  /** Webcast ID */
  id: Scalars['ID']['input'];
};

/** Webcast duplication failed */
export type DuplicateWebcastProblem = {
  __typename?: 'DuplicateWebcastProblem';
  code: DuplicateWebcastProblemCode;
};

export enum DuplicateWebcastProblemCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type DuplicateWebcastResult = DuplicateWebcastProblem | DuplicateWebcastSuccess | ValidationErrors;

export type DuplicateWebcastSuccess = {
  __typename?: 'DuplicateWebcastSuccess';
  webcast: Webcast;
};

/** Ecdn configuration */
export type ECdnSettings = {
  __typename?: 'ECdnSettings';
  isActive: Scalars['Boolean']['output'];
  type: ECdnType;
};

export type ECdnSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  type?: InputMaybe<ECdnType>;
};

export enum ECdnType {
  HIVE = 'HIVE',
  KOLLECTIVE = 'KOLLECTIVE',
  RAMP = 'RAMP',
  VBRICK_OMNICACHE = 'VBRICK_OMNICACHE',
  VBRICK_P2P = 'VBRICK_P2P',
  VBRICK_P2P_AND_OMNICACHE = 'VBRICK_P2P_AND_OMNICACHE',
}

export type EmailList = {
  __typename?: 'EmailList';
  emails: Array<Scalars['String']['output']>;
};

export type EmailListResult = EmailList | NotSupportedForThisQuery;

export type EmailRegistrationPolicy = {
  __typename?: 'EmailRegistrationPolicy';
  /** Indicates if policy is enabled */
  enabled: Scalars['Boolean']['output'];
  /** Registration form configuration */
  registrationFormConfiguration: RegistrationFormConfiguration;
  /** If true, requires that users verify their email address by entering a code sent to their email */
  requireEmailVerification: Scalars['Boolean']['output'];
};

export type EmailWhitelistPolicy = {
  __typename?: 'EmailWhitelistPolicy';
  /**
   * List of whitelisted emails.
   * Email templates with wildcard symbol (*) are supported.
   * All emails are sorted alphabetically, with the wildcard items on top of the list.
   */
  emails: Array<Scalars['String']['output']>;
  /** Is policy enabled. */
  enabled: Scalars['Boolean']['output'];
  /**
   * Registration form configuration.
   * @deprecated Use EmailRegistrationPolicy.registrationFormConfiguration instead
   */
  registrationFormConfiguration: RegistrationFormConfiguration;
  /** If true, requires that users verify their email address by entering a code sent to their email */
  requireEmailVerification: Scalars['Boolean']['output'];
};

export type EnableVodInput = {
  webcastId: Scalars['ID']['input'];
};

export type EnableVodProblem = {
  __typename?: 'EnableVodProblem';
  code?: Maybe<EnableVodProblemCode>;
};

export enum EnableVodProblemCode {
  VOD_VIDEO_NOT_CONFIGURED = 'VOD_VIDEO_NOT_CONFIGURED',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type EnableVodResult = EnableVodProblem | EnableVodSuccess;

export type EnableVodSuccess = {
  __typename?: 'EnableVodSuccess';
  webcastId: Scalars['ID']['output'];
};

export type Encoding = {
  __typename?: 'Encoding';
  name: Scalars['String']['output'];
};

export type EventPermission = {
  __typename?: 'EventPermission';
  collaborators: Array<User>;
  moderators: Array<User>;
  owners: Array<User>;
  type: EventPermissionType;
};

export enum EventPermissionType {
  PRIVATE = 'PRIVATE',
  PUBLIC = 'PUBLIC',
}

export enum EventStage {
  LIVE = 'LIVE',
  POSTLIVE = 'POSTLIVE',
  PRELIVE = 'PRELIVE',
}

export enum EventStartVerificationPolicy {
  /**
   * A default policy.
   * All active event language (primary + additional) streams are required.
   */
  ALL_ACTIVE_LANGUAGE_STREAMS_REQUIRED = 'ALL_ACTIVE_LANGUAGE_STREAMS_REQUIRED',
  /**
   * Only active primary event language stream is required.
   * User can start multilang (RTMP) event without active additional language streams.
   *
   * Note: recordings will NOT start for inactive additional language streams.
   * @deprecated This policy is deprecated and will be removed in the future. Use ONLY_ACTIVE_PRIMARY_OR_BACKUP_LANGUAGE_STREAM_REQUIRED instead.
   */
  ONLY_ACTIVE_PRIMARY_LANGUAGE_STREAM_REQUIRED = 'ONLY_ACTIVE_PRIMARY_LANGUAGE_STREAM_REQUIRED',
  /**
   * Either active primary or backup event language stream is required.
   *
   * Notes:
   * - recordings may not be available
   * - download of subtitles is not possible
   * - no auto-failover available
   */
  ONLY_ACTIVE_PRIMARY_OR_BACKUP_LANGUAGE_STREAM_REQUIRED = 'ONLY_ACTIVE_PRIMARY_OR_BACKUP_LANGUAGE_STREAM_REQUIRED',
}

/** Minute-by-minute metrics for the duration of a webcast event */
export type EventTimeline = {
  __typename?: 'EventTimeline';
  /** Ordered list of data points, one per minute from stream start */
  dataPoints: Array<EventTimelineDataPoint>;
};

/** Metrics snapshot for a single minute of the event */
export type EventTimelineDataPoint = {
  __typename?: 'EventTimelineDataPoint';
  /** Number of active plays (concurrent viewers) at this minute */
  activePlays: Scalars['Int']['output'];
  /** Minute offset relative to stream start (0-based) */
  minuteFromStart: Scalars['Int']['output'];
  /** Absolute timestamp in UTC (ISO 8601) */
  timestamp: Scalars['DateTime']['output'];
};

export type Font = {
  __typename?: 'Font';
  /** Optional file asset of a font. Should typically be present if this font is not a default one. */
  asset?: Maybe<Asset>;
  /** ID of the font that can be used to assign it to LSPRO instance settings. */
  id: Scalars['ID']['output'];
  /** Marks whether this font is a standard one (i.e. accessible in global configuration). */
  isStandard: Scalars['Boolean']['output'];
  /** Display name of a font */
  name: Scalars['String']['output'];
};

export type GenerateReportInput = {
  type: ReportType;
  webcastId: Scalars['ID']['input'];
};

export type GenerateReportProblem = {
  __typename?: 'GenerateReportProblem';
  code?: Maybe<GenerateReportProblemCode>;
};

export enum GenerateReportProblemCode {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_POSTLIVE_STATE = 'WEBCAST_NOT_IN_POSTLIVE_STATE',
}

export type GenerateReportResult = GenerateReportProblem | GenerateReportSuccess;

export type GenerateReportSuccess = {
  __typename?: 'GenerateReportSuccess';
  report?: Maybe<Report>;
};

export type GetMonthlyStreamingUsageResult = {
  __typename?: 'GetMonthlyStreamingUsageResult';
  month: Scalars['Int']['output'];
  quota: Quota;
  usedMinutes: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

export type GetSessionProblem = {
  __typename?: 'GetSessionProblem';
  code?: Maybe<GetSessionProblemCode>;
};

export enum GetSessionProblemCode {
  WEBCAST_IN_PRELIVE_STATE = 'WEBCAST_IN_PRELIVE_STATE',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type GetSessionResult = GetSessionProblem | GetSessionSuccess;

export type GetSessionSuccess = {
  __typename?: 'GetSessionSuccess';
  endDate?: Maybe<Scalars['DateTime']['output']>;
  highlightedSpeakers: Array<HighlightedSpeakers>;
  liveStreams: Array<LiveStreamInfo>;
  pushedSlides: Array<PushedSlide>;
  startDate: Scalars['DateTime']['output'];
};

export type GetStreamingUsageProblem = {
  __typename?: 'GetStreamingUsageProblem';
  code?: Maybe<GetStreamingUsageProblemCode>;
};

export enum GetStreamingUsageProblemCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type GetStreamingUsageReportProblem = {
  __typename?: 'GetStreamingUsageReportProblem';
  code: GetStreamingUsageReportProblemCode;
};

export enum GetStreamingUsageReportProblemCode {
  INVALID_DATE_RANGE = 'INVALID_DATE_RANGE',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type GetStreamingUsageReportResult = GetStreamingUsageReportProblem | GetStreamingUsageReportSuccess;

export type GetStreamingUsageReportSuccess = {
  __typename?: 'GetStreamingUsageReportSuccess';
  downloadUrl: Scalars['String']['output'];
};

export type GetStreamingUsageResult = GetMonthlyStreamingUsageResult | GetStreamingUsageProblem;

export type GetUsersProblem = {
  __typename?: 'GetUsersProblem';
  code?: Maybe<GetUsersProblemCode>;
};

export enum GetUsersProblemCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type GetUsersResult = GetUsersProblem | GetUsersSuccess;

export type GetUsersSuccess = {
  __typename?: 'GetUsersSuccess';
  users: Array<User>;
};

export type GetVideoManagerProblem = {
  __typename?: 'GetVideoManagerProblem';
  code: GetVideoManagerProblemCode;
};

export enum GetVideoManagerProblemCode {
  VMPRO_LINK_MISSING = 'VMPRO_LINK_MISSING',
}

export type GetVideoManagerResult = GetVideoManagerProblem | VideoManager;

export type GetVideoManagersProblem = {
  __typename?: 'GetVideoManagersProblem';
  code: GetVideoManagersProblemCode;
};

export enum GetVideoManagersProblemCode {
  VMPRO_LINK_MISSING = 'VMPRO_LINK_MISSING',
}

export type GetVideoManagersResult = GetVideoManagersProblem | GetVideoManagersSuccess;

export type GetVideoManagersSuccess = {
  __typename?: 'GetVideoManagersSuccess';
  videoManagers: Array<VideoManager>;
};

export type GetVideoProblem = {
  __typename?: 'GetVideoProblem';
  code: GetVideoProblemCode;
};

export enum GetVideoProblemCode {
  UNAUTHORIZED_ACCESS = 'UNAUTHORIZED_ACCESS',
  VIDEO_NOT_FOUND = 'VIDEO_NOT_FOUND',
  VMPRO_LINK_MISSING = 'VMPRO_LINK_MISSING',
}

export type GetVideoResult = GetVideoProblem | Video;

export type GlossaryInput = {
  /** Action enum (ADD or REMOVE). */
  action: ItemListAction;
  /**
   * List of entries that should either be added or removed.
   * "term" property is stored case sensitive and behaves like a key:
   * - On ADD, if entry with duplicated "term" property already exists, new entry is ignored.
   * - On REMOVE, entries are found and removed by "term", therefore other properties are ignored.
   *   If key is not found, entry is ignored.
   */
  entries: Array<SubtitleGlossaryEntryInput>;
};

export type GlossaryList = {
  __typename?: 'GlossaryList';
  entries: Array<SubtitleGlossaryEntry>;
};

/** Not supported for `webcasts` query */
export type GlossaryResult = GlossaryList | NotSupportedForThisQuery;

export type HighlightedSpeakers = {
  __typename?: 'HighlightedSpeakers';
  offsetInMs?: Maybe<Scalars['Long']['output']>;
  speakerIds: Array<Scalars['ID']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type IdentityProvider = {
  __typename?: 'IdentityProvider';
  alias: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type Ingest = {
  __typename?: 'Ingest';
  /** Backup ingest server url, used in case primary server is down */
  backupServer: Scalars['String']['output'];
  /** Password for authenticating push connection */
  password: Scalars['String']['output'];
  /** Primary ingest server url */
  primaryServer: Scalars['String']['output'];
  /** Stream name / key */
  streamName: Scalars['String']['output'];
  /** User name for authenticating push connection */
  username: Scalars['String']['output'];
};

/**
 * Ingest input can contain either srt or rtmp field.
 * In case both fields are sent, MORE_THAN_ONE_INGEST_FIELD_PROVIDED problem will be returned
 */
export type IngestInput = {
  rtmp?: InputMaybe<RtmpIngestInput>;
  srt?: InputMaybe<SrtIngestInput>;
};

export enum IngestProtocol {
  RTMP = 'RTMP',
  SRT = 'SRT',
}

/** Chat feature for lspro successfully initialized */
export type InitializeChatFeatureResult = {
  __typename?: 'InitializeChatFeatureResult';
  chatProviderAccountId: Scalars['String']['output'];
};

export type InitializeEventProblem = {
  __typename?: 'InitializeEventProblem';
  /** Code indicating the problem */
  code: InitializeEventProblemCode;
};

export enum InitializeEventProblemCode {
  ENCODER_CONNECTED = 'ENCODER_CONNECTED',
  INGEST_PROTOCOL_NOT_CHOSEN = 'INGEST_PROTOCOL_NOT_CHOSEN',
  LANGUAGES_NOT_CHOSEN = 'LANGUAGES_NOT_CHOSEN',
  OPERATION_ALREADY_IN_PROGRESS = 'OPERATION_ALREADY_IN_PROGRESS',
  SUBTITLE_GENERATION_SETUP_FAILED = 'SUBTITLE_GENERATION_SETUP_FAILED',
  SUBTITLE_PROVIDER_NOT_AVAILABLE = 'SUBTITLE_PROVIDER_NOT_AVAILABLE',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type InitializeEventResult = InitializeEventProblem | InitializeEventSuccess;

export type InitializeEventSuccess = {
  __typename?: 'InitializeEventSuccess';
  results: Array<StreamingOperationResult>;
};

export type InviteUserInput = {
  email: Scalars['String']['input'];
  lsproId: Scalars['ID']['input'];
  roles: Array<Role>;
};

export type InviteUserProblem = {
  __typename?: 'InviteUserProblem';
  code: InviteUserProblemCode;
};

export enum InviteUserProblemCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  LSPRO_ROLE_LIMIT_EXCEEDED = 'LSPRO_ROLE_LIMIT_EXCEEDED',
  SSO_BASED_USER_MANAGEMENT_ENABLED = 'SSO_BASED_USER_MANAGEMENT_ENABLED',
  USER_ALREADY_PRESENT = 'USER_ALREADY_PRESENT',
}

export type InviteUserResult = InviteUserProblem | InviteUserSuccess;

export type InviteUserSuccess = {
  __typename?: 'InviteUserSuccess';
  user: User;
};

export enum ItemListAction {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}

export type Language = CustomLanguage | StandardLanguage;

export type LanguageConfigurationInput = {
  /** Set as primary language */
  isPrimary?: InputMaybe<Scalars['Boolean']['input']>;
  /** Language */
  language: Scalars['String']['input'];
};

export type LinkVmproInput = {
  authorizationCode: Scalars['String']['input'];
  redirectUri: Scalars['String']['input'];
};

export type LinkVmproProblem = {
  __typename?: 'LinkVmproProblem';
  code: LinkVmproProblemCode;
};

export enum LinkVmproProblemCode {
  AUTHORIZATION_INVALID = 'AUTHORIZATION_INVALID',
}

export type LinkVmproResult = LinkVmproProblem | LinkVmproSuccess;

export type LinkVmproSuccess = {
  __typename?: 'LinkVmproSuccess';
  authorizationCode: Scalars['String']['output'];
  redirectUri: Scalars['String']['output'];
};

export type LiveStreamInfo = {
  __typename?: 'LiveStreamInfo';
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
};

export type LiveStreamPro = {
  __typename?: 'LiveStreamPro';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type LiveStreamProDefaultSettings = {
  __typename?: 'LiveStreamProDefaultSettings';
  allowTranscodingProfileSelection: Scalars['Boolean']['output'];
  /**
   * Default ingest settings applied when creating new webcasts.
   * If not configured, defaults to RTMP without authentication.
   */
  defaultIngestSettings: DefaultIngestSettings;
  /** @deprecated Use defaultIngestSettings instead */
  ingestAuthenticationAsDefault: Scalars['Boolean']['output'];
  privateEventAsDefault: Scalars['Boolean']['output'];
  restrictAttendanceReport: Scalars['Boolean']['output'];
  showWatermarkingAsDefault: Scalars['Boolean']['output'];
  singleSignOnAsDefault: Scalars['Boolean']['output'];
};

export type LiveStreamProFeature = {
  /** Indicates whether the feature is enabled */
  enabled: Scalars['Boolean']['output'];
};

export enum LiveStreamProFeatureType {
  AI_SUBTITLES = 'AI_SUBTITLES',
  BROWSER_BASED_STUDIO = 'BROWSER_BASED_STUDIO',
  CUSTOM_DOMAINS = 'CUSTOM_DOMAINS',
  CUSTOM_VOD_MANIFEST_URL = 'CUSTOM_VOD_MANIFEST_URL',
  LIVE_STREAMING_HOURS = 'LIVE_STREAMING_HOURS',
  SSO_BASED_USER_MANAGEMENT = 'SSO_BASED_USER_MANAGEMENT',
  TERMS_AND_CONDITIONS = 'TERMS_AND_CONDITIONS',
  WATERMARKING = 'WATERMARKING',
}

export type LiveStreamProSettings = {
  __typename?: 'LiveStreamProSettings';
  /** Appearance settings. Includes things like color, themes, logo files, etc. */
  appearance: AppearanceSettings;
  /** Additional compliance form to be displayed. Can be empty. */
  complianceForm: ComplianceForm;
  /** Localized (per language) data protection text to be displayed. */
  dataProtectionForm: DataProtectionForm;
  /** Default settings per channel */
  defaultSettings: LiveStreamProDefaultSettings;
  /** A policy that defines requirements to start a live event. */
  eventStartVerificationPolicy: EventStartVerificationPolicy;
  /** List of feature settings */
  features: Array<LiveStreamProFeature>;
  /** A flag indicating whether user wants to display defaultComplianceForm from global configuration or not. */
  includeDefaultComplianceForm: Scalars['Boolean']['output'];
  /** List of supported and custom languages */
  languages: Array<Language>;
  /** ID of given LSPRO */
  lsproId: Scalars['String']['output'];
  /** Security settings */
  securitySettings: SecuritySettings;
  /** List of supported fonts available for LSPRO instance (standard + custom) */
  supportedFonts: Array<Font>;
  /** List of themes available for LSPRO instance. */
  themes: Array<AppearanceTheme>;
  /** Transcoding profile settings */
  transcodingProfileSettings?: Maybe<TranscodingProfileSettings>;
};

export type LiveStreaming = {
  __typename?: 'LiveStreaming';
  defaultParameters: LiveStreamingDefaultParameters;
  ingestProtocol: IngestProtocol;
  parameters: LiveStreamingParameters;
  streams: Array<Stream>;
  transcodingProfileId: Scalars['String']['output'];
};

/** Default live streaming parameters */
export type LiveStreamingDefaultParameters = {
  __typename?: 'LiveStreamingDefaultParameters';
  rtmp: RtmpLiveStreamingDefaultParameters;
  srt: SrtLiveStreamingDefaultParameters;
};

export type LiveStreamingHoursFeature = LiveStreamProFeature & {
  __typename?: 'LiveStreamingHoursFeature';
  enabled: Scalars['Boolean']['output'];
  quotaType: QuotaType;
  value: Scalars['Int']['output'];
};

export type LiveStreamingParameters = RtmpLiveStreamingParameters | SrtLiveStreamingParameters;

export type LocalizedComplianceFormEntry = {
  __typename?: 'LocalizedComplianceFormEntry';
  language: Language;
  text: Scalars['String']['output'];
};

export type LocalizedComplianceSettingsEntryInput = {
  complianceFormText: Scalars['String']['input'];
  dataProtectionText: Scalars['String']['input'];
  language: Scalars['String']['input'];
};

export type LocalizedDataProtectionEntry = {
  __typename?: 'LocalizedDataProtectionEntry';
  language: Language;
  text: Scalars['String']['output'];
};

export type LocalizedText = {
  __typename?: 'LocalizedText';
  language: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type LocalizedTextInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export type MetricLanguageStats = {
  __typename?: 'MetricLanguageStats';
  language: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type MetricStats = {
  __typename?: 'MetricStats';
  perLanguage: Array<MetricLanguageStats>;
  total: Scalars['Int']['output'];
};

export type ModeratedChatSettings = ChatSettings & {
  __typename?: 'ModeratedChatSettings';
  allowBeforeLive: Scalars['Boolean']['output'];
  type: ChatType;
  useProvidedUsername: Scalars['Boolean']['output'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /**
   * Adds a speaker to a webcast (max 6 speakers per webcast).
   * Requires a previously uploaded picture (use createPicture first).
   */
  addSpeaker: AddSpeakerResult;
  /** Archives webcast */
  archiveWebcast: ArchiveWebcastResult;
  cleanupLiveStreamPro?: Maybe<LiveStreamPro>;
  /** Clears VOD chapters thumbnail assets and replaces them with fresh assets. */
  clearVodChaptersThumbnails: ClearVodChaptersThumbnailsResult;
  createAppearanceAsset: CreateAppearanceAssetResult;
  /** Creates chat on a given Webcast */
  createChat: CreateChatResult;
  createChatUsers?: Maybe<CreateChatUsersResult>;
  createFont: CreateFontResult;
  createLiveStreamPro: LiveStreamPro;
  /** Creates an upload link for a picture (eg. speaker picture). */
  createPicture: CreatePictureResult;
  /**
   * Creates presentation for given webcast
   *
   * groupId - unique key that is used to group all language versions for a given presentation.
   */
  createPresentation: CreatePresentationResult;
  createTheme: CreateThemeResult;
  /** Creates webcast */
  createWebcast: CreateWebcastResult;
  createWebcastCoverImage: AssetCreateResult;
  deleteAppearanceAsset: DeleteAppearanceAssetResult;
  /** Deletes chat on a given Webcast */
  deleteChat: DeleteChatResult;
  deleteFont: DeleteFontResult;
  /** Deletes presentation */
  deletePresentation: DeletePresentationResult;
  /** Deletes a speaker from a webcast */
  deleteSpeaker: DeleteSpeakerResult;
  deleteTheme: DeleteThemeResult;
  /**
   * Removes VOD chapters for given Webcast.
   * The updated list of (remaining) chapters is automatically sorted by offset.
   */
  deleteVodChapters: DeleteVodChaptersResult;
  /** Removes VOD slide markers for given Webcast. */
  deleteVodSlideMarkers: DeleteVodSlideMarkersResult;
  /** Deletes webcast */
  deleteWebcast: DeleteWebcastResult;
  deleteWebcastCoverImage: AssetDeleteResult;
  /** Duplicates an existing webcast */
  duplicateWebcast: DuplicateWebcastResult;
  /** Enables VOD for a given Webcast */
  enableVod: EnableVodResult;
  generateReport?: Maybe<GenerateReportResult>;
  /** Initializes chat functionality on LSPro account, allowing for chats on Webcasts to be enabled/disabled */
  initializeChatFeature: InitializeChatFeatureResult;
  initializeEvent: InitializeEventResult;
  /** Invites user to a given LSPRO Manager */
  inviteUser: InviteUserResult;
  linkVmpro: LinkVmproResult;
  /** Injects "slide_push" event to the specified live webcast */
  pushSlide: PushSlideResult;
  /** Removes user from given LSPRO Manager */
  removeUser: RemoveUserResult;
  /** Reverts VOD slide markers to their original offsets, restoring all deleted markers for given Webcast. */
  revertVodSlideMarkers: RevertVodSlideMarkersResult;
  /**
   * Saves the configuration of existing blastream room with specified webcastId.
   * This configuration is then used as a default template for all new rooms in its parent LSPRO.
   */
  saveBlaStreamRoomSettingsAsDefault: SaveBlaStreamRoomSettingsAsDefaultResult;
  /**
   * Sets or clears currently active (highlighted) speakers for a webcast.
   * Only allowed when webcast is in LIVE or LIVE_TEST state.
   * Pass empty speakerIds array to clear active speakers.
   */
  setActiveSpeakers: SetActiveSpeakersResult;
  setDefaultTheme: SetDefaultThemeResult;
  setEventAccessPublic: SetEventAccessPublicResult;
  /** Sets roles to user */
  setUserRoles: SetUserRolesResult;
  startEvent: StartEventResult;
  startLiveTest: StartLiveTestResult;
  stopEvent: StopEventResult;
  stopLiveTest: StopLiveTestResult;
  /** Unarchives webcast */
  unarchiveWebcast: UnarchiveWebcastResult;
  /** Update access code policy for given webcast */
  updateAccessCodePolicy: UpdateAccessCodePolicyResult;
  updateAppearanceSettings: UpdateAppearanceSettingsResult;
  /** Updates chat settings */
  updateChat: UpdateChatResult;
  updateDefaultTranscodingProfile: UpdateDefaultTranscodingProfileResult;
  updateEmailRegistrationPolicy: UpdateEmailRegistrationPolicyResult;
  /** Update email verification on all security policies which support to require email verification */
  updateEmailVerification: UpdateEmailVerificationResult;
  updateEmailWhitelistPolicy: UpdateEmailWhitelistPolicyResult;
  /** Update event permission for given webcast */
  updateEventPermission: UpdateEventPermissionResult;
  updateEventStartVerificationPolicy: UpdateEventStartVerificationPolicyResult;
  updateFont: UpdateFontResult;
  updateLiveStreamPro?: Maybe<LiveStreamPro>;
  /** @deprecated Use updateLiveStreamProComplianceSettings instead */
  updateLiveStreamProComplianceForm: UpdateComplianceFormResult;
  updateLiveStreamProComplianceSettings: UpdateComplianceSettingsResult;
  /** @deprecated Use updateLiveStreamProComplianceSettings instead */
  updateLiveStreamProDataProtectionForm: UpdateDataProtectionFormResult;
  updateLiveStreamProDefaultSettings: UpdateLiveStreamProDefaultSettingsResult;
  updateLiveStreamProSecuritySettings: UpdateLiveStreamProSecuritySettingsResult;
  /** Update Referrer Protection for given webcast by providing boolean flag and/or list of domains */
  updateReferrerProtectionPolicy: UpdateReferrerProtectionResult;
  /** Update single sign-on policy for given webcast by providing boolean flag and/or list of emails, groups, uids */
  updateSingleSignOnPolicy: UpdateSingleSignOnPolicyResult;
  /** Updates a speaker's data (name, position, or picture) */
  updateSpeaker: UpdateSpeakerResult;
  updateStreamViewerSource: UpdateStreamViewerSourceResult;
  updateTheme: UpdateThemeResult;
  /** Update Token Protection policy for given webcast by providing boolean flag */
  updateTokenProtectionPolicy: UpdateTokenProtectionResult;
  /** Updates VOD settings for a given Webcast */
  updateVod: UpdateVodResult;
  /** Updates VOD slide markers for given Webcast. */
  updateVodSlideMarkers: UpdateVodSlideMarkersResult;
  /** Updates webcast */
  updateWebcast: UpdateWebcastResult;
  /**
   * Upserts VOD chapters for given Webcast.
   * Each chapter must have at least one (primary) language title configured.
   * If title is not configured for a language, primary language title is used by default.
   * The updated list of chapters is automatically sorted by offset.
   */
  upsertVodChapters: UpsertVodChaptersResult;
};

export type MutationAddSpeakerArgs = {
  input: AddSpeakerInput;
};

export type MutationArchiveWebcastArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationCleanupLiveStreamProArgs = {
  lsproId: Scalars['ID']['input'];
};

export type MutationClearVodChaptersThumbnailsArgs = {
  input: ClearVodChaptersThumbnailsInput;
};

export type MutationCreateAppearanceAssetArgs = {
  input: CreateAppearanceAssetInput;
};

export type MutationCreateChatArgs = {
  input: CreateChatInput;
};

export type MutationCreateChatUsersArgs = {
  lsproId: Scalars['ID']['input'];
};

export type MutationCreateFontArgs = {
  input: CreateFontInput;
};

export type MutationCreateLiveStreamProArgs = {
  input: CreateLiveStreamProInput;
};

export type MutationCreatePictureArgs = {
  input: CreatePictureInput;
};

export type MutationCreatePresentationArgs = {
  groupId?: InputMaybe<Scalars['ID']['input']>;
  input: CreatePresentationInput;
};

export type MutationCreateThemeArgs = {
  input: CreateThemeInput;
};

export type MutationCreateWebcastArgs = {
  input: CreateWebcastInput;
};

export type MutationCreateWebcastCoverImageArgs = {
  eventStage: EventStage;
  language?: InputMaybe<Scalars['String']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type MutationDeleteAppearanceAssetArgs = {
  input: DeleteAppearanceAssetInput;
};

export type MutationDeleteChatArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationDeleteFontArgs = {
  input: DeleteFontInput;
};

export type MutationDeletePresentationArgs = {
  input: DeletePresentationInput;
};

export type MutationDeleteSpeakerArgs = {
  input: DeleteSpeakerInput;
};

export type MutationDeleteThemeArgs = {
  input: DeleteThemeInput;
};

export type MutationDeleteVodChaptersArgs = {
  input: DeleteVodChaptersInput;
};

export type MutationDeleteVodSlideMarkersArgs = {
  input: DeleteVodSlideMarkersInput;
};

export type MutationDeleteWebcastArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDeleteWebcastCoverImageArgs = {
  eventStage: EventStage;
  language?: InputMaybe<Scalars['String']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type MutationDuplicateWebcastArgs = {
  input: DuplicateWebcastInput;
};

export type MutationEnableVodArgs = {
  input: EnableVodInput;
};

export type MutationGenerateReportArgs = {
  input: GenerateReportInput;
};

export type MutationInitializeChatFeatureArgs = {
  lsproId: Scalars['ID']['input'];
};

export type MutationInitializeEventArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationInviteUserArgs = {
  input: InviteUserInput;
};

export type MutationLinkVmproArgs = {
  input: LinkVmproInput;
};

export type MutationPushSlideArgs = {
  input: PushSlideInput;
};

export type MutationRemoveUserArgs = {
  input: RemoveUserInput;
};

export type MutationRevertVodSlideMarkersArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationSaveBlaStreamRoomSettingsAsDefaultArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationSetActiveSpeakersArgs = {
  input: SetActiveSpeakersInput;
};

export type MutationSetDefaultThemeArgs = {
  input: SetDefaultThemeInput;
};

export type MutationSetEventAccessPublicArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationSetUserRolesArgs = {
  input: SetUserRolesInput;
};

export type MutationStartEventArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationStartLiveTestArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationStopEventArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationStopLiveTestArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationUnarchiveWebcastArgs = {
  webcastId: Scalars['ID']['input'];
};

export type MutationUpdateAccessCodePolicyArgs = {
  input: UpdateAccessCodePolicyInput;
};

export type MutationUpdateAppearanceSettingsArgs = {
  input: UpdateAppearanceSettingsInput;
};

export type MutationUpdateChatArgs = {
  input: UpdateChatInput;
};

export type MutationUpdateDefaultTranscodingProfileArgs = {
  input?: InputMaybe<UpdateDefaultTranscodingProfileInput>;
};

export type MutationUpdateEmailRegistrationPolicyArgs = {
  input: UpdateEmailRegistrationPolicyInput;
};

export type MutationUpdateEmailVerificationArgs = {
  input: UpdateEmailVerificationInput;
};

export type MutationUpdateEmailWhitelistPolicyArgs = {
  input: UpdateEmailWhitelistPolicyInput;
};

export type MutationUpdateEventPermissionArgs = {
  input: UpdateEventPermissionInput;
};

export type MutationUpdateEventStartVerificationPolicyArgs = {
  input: UpdateEventStartVerificationPolicyInput;
};

export type MutationUpdateFontArgs = {
  input: UpdateFontInput;
};

export type MutationUpdateLiveStreamProArgs = {
  input: UpdateLiveStreamProInput;
};

export type MutationUpdateLiveStreamProComplianceFormArgs = {
  input: UpdateComplianceFormInput;
};

export type MutationUpdateLiveStreamProComplianceSettingsArgs = {
  input: UpdateComplianceSettingsInput;
};

export type MutationUpdateLiveStreamProDataProtectionFormArgs = {
  input: UpdateDataProtectionFormInput;
};

export type MutationUpdateLiveStreamProDefaultSettingsArgs = {
  input: UpdateLiveStreamProDefaultSettingsInput;
};

export type MutationUpdateLiveStreamProSecuritySettingsArgs = {
  input: UpdateLiveStreamProSecuritySettingsInput;
};

export type MutationUpdateReferrerProtectionPolicyArgs = {
  input: UpdateReferrerProtectionPolicyInput;
};

export type MutationUpdateSingleSignOnPolicyArgs = {
  input: UpdateSingleSignOnPolicyInput;
};

export type MutationUpdateSpeakerArgs = {
  input: UpdateSpeakerInput;
};

export type MutationUpdateStreamViewerSourceArgs = {
  input: UpdateStreamViewerSourceInput;
};

export type MutationUpdateThemeArgs = {
  input: UpdateThemeInput;
};

export type MutationUpdateTokenProtectionPolicyArgs = {
  input: UpdateTokenProtectionPolicyInput;
};

export type MutationUpdateVodArgs = {
  input: UpdateVodInput;
};

export type MutationUpdateVodSlideMarkersArgs = {
  input: UpdateVodSlideMarkersInput;
};

export type MutationUpdateWebcastArgs = {
  input: UpdateWebcastInput;
};

export type MutationUpsertVodChaptersArgs = {
  input: UpsertVodChaptersInput;
};

export type NoVideoManagerSecurityPolicy = {
  __typename?: 'NoVideoManagerSecurityPolicy';
  reason: Scalars['String']['output'];
};

export type NotAuthorized = {
  __typename?: 'NotAuthorized';
  message?: Maybe<Scalars['String']['output']>;
};

export type NotFound = {
  __typename?: 'NotFound';
  message?: Maybe<Scalars['String']['output']>;
};

export type NotSupportedForThisQuery = {
  __typename?: 'NotSupportedForThisQuery';
  reason: Scalars['String']['output'];
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor?: Maybe<Scalars['String']['output']>;
};

export enum PictureType {
  SPEAKER = 'SPEAKER',
}

export type Pid = {
  __typename?: 'Pid';
  language: Scalars['String']['output'];
  pid: Scalars['Int']['output'];
};

export type PidInput = {
  language: Scalars['String']['input'];
  pid: Scalars['Int']['input'];
};

export type Playback = {
  __typename?: 'Playback';
  backupUrl?: Maybe<Scalars['Url']['output']>;
  primaryUrl: Scalars['Url']['output'];
  token: Scalars['String']['output'];
};

export type PlaybackResult = NotSupportedForThisQuery | PlaybackSettings;

export type PlaybackSettings = {
  __typename?: 'PlaybackSettings';
  sources: VideoSources;
  storyboard?: Maybe<Storyboard>;
};

export enum PlaybackState {
  NOT_READY = 'NOT_READY',
  READY = 'READY',
  UNKNOWN = 'UNKNOWN',
}

export type Presentation = {
  __typename?: 'Presentation';
  /** Download URL */
  downloadLink?: Maybe<Scalars['String']['output']>;
  /** Unique key that is used to group all language versions for a given presentation. */
  groupId: Scalars['String']['output'];
  /** Presentation identifier */
  id: Scalars['String']['output'];
  /** language (ISO 639-1 code) */
  language: Scalars['String']['output'];
  /** Extracted slide image URLs */
  slides?: Maybe<Array<PresentationSlide>>;
  /** Original name of presentation file */
  sourceFileName: Scalars['String']['output'];
  /** Current status */
  status: PresentationStatus;
  /** Upload link details */
  uploadLink: UploadLink;
};

export type PresentationSlide = {
  __typename?: 'PresentationSlide';
  downloadUrl: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  thumbnailDownloadUrl: Scalars['String']['output'];
};

export type PresentationSlidesExtractionStatus = {
  __typename?: 'PresentationSlidesExtractionStatus';
  processedSlides?: Maybe<Scalars['Int']['output']>;
  progress: ProgressStatus;
  totalSlides?: Maybe<Scalars['Int']['output']>;
};

export type PresentationStatus = {
  __typename?: 'PresentationStatus';
  /** Slide extraction process status */
  slidesExtractionStatus: PresentationSlidesExtractionStatus;
  /** Upload process status */
  uploadStatus: PresentationUploadStatus;
};

export type PresentationUploadStatus = {
  __typename?: 'PresentationUploadStatus';
  progress: ProgressStatus;
};

export enum ProgressStatus {
  FAILED = 'FAILED',
  IN_PROGRESS = 'IN_PROGRESS',
  NOT_STARTED = 'NOT_STARTED',
  PASSED = 'PASSED',
}

export type ProgressiveVideoSource = {
  __typename?: 'ProgressiveVideoSource';
  quality: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['Url']['output'];
};

export type PushSlideInput = {
  /** Presentation group ID */
  groupId: Scalars['ID']['input'];
  /** slide index */
  index: Scalars['Int']['input'];
  /** Webcast ID associated with given presentation */
  webcastId: Scalars['ID']['input'];
};

/** Slide push has failed */
export type PushSlideProblem = {
  __typename?: 'PushSlideProblem';
  /** Code indicating the problem */
  code: PushSlideProblemCode;
};

export enum PushSlideProblemCode {
  ALL_PUSHES_FAILED = 'ALL_PUSHES_FAILED',
  PRESENTATION_NOT_FOUND = 'PRESENTATION_NOT_FOUND',
  PUSH_PARTIALLY_FAILED = 'PUSH_PARTIALLY_FAILED',
  SLIDE_INDEX_OUT_OF_BOUNDS = 'SLIDE_INDEX_OUT_OF_BOUNDS',
  WEBCAST_NOT_LIVE = 'WEBCAST_NOT_LIVE',
}

export type PushSlideResult = PushSlideProblem | PushSlideSuccess | ValidationErrors;

/** Slide has been successfully pushed */
export type PushSlideSuccess = {
  __typename?: 'PushSlideSuccess';
  /** Presentation group ID */
  groupId: Scalars['ID']['output'];
  /** slide index */
  index: Scalars['Int']['output'];
  results: Array<StreamingOperationResult>;
};

export type PushedSlide = {
  __typename?: 'PushedSlide';
  groupId: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  offsetInMs?: Maybe<Scalars['Int']['output']>;
  timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /**
   * Returns the upload status of an asset by its ID.
   * Returns null if the asset does not exist.
   */
  assetUploadStatus?: Maybe<AssetUploadStatus>;
  /** Queries blastream room connection info. Creates a new room if the room doesn't exist. */
  blaStreamRoom: BlaStreamRoom;
  /** Returns global configuration settings */
  configuration: Configuration;
  /** Returns all the LSPRO Manager accounts for the user who is querying */
  currentUser?: Maybe<CurrentUser>;
  /** Returns effective roles of user for webcast */
  currentUserRolesForWebcast: Array<Role>;
  /** Returns IDs of hardcoded dummy data */
  dummyData: DummyData;
  /** Returns IDP List configured on a LSPro */
  identityProviders?: Maybe<Array<IdentityProvider>>;
  /** Returns LSPro settings */
  lsproSettings?: Maybe<LiveStreamProSettings>;
  /** @deprecated Use reportMetadata instead */
  report?: Maybe<Report>;
  reportMetadata: ReportMetadataResult;
  /**
   * Returns active webcast session.
   * Must be called during LIVE state, otherwise problem is returned.
   */
  session: GetSessionResult;
  /** Returns streaming usage for given lspro */
  streamingUsage: GetStreamingUsageResult;
  /** Returns download url to usage report for provided date range */
  streamingUsageReport: GetStreamingUsageReportResult;
  /** Returns all users for given LSPRO Manager */
  users: GetUsersResult;
  video: GetVideoResult;
  videoManager: GetVideoManagerResult;
  videoManagers: GetVideoManagersResult;
  videos: VideoSearchResult;
  /** Returns webcast with given ID */
  webcast: Webcast;
  /**
   * Returns paginated webcast list for a given LSPRO id.
   *
   * For "Upcoming" events use:
   * - filterBy->plannedStartAt->from: Now
   * - filterBy->states->[PLANNED]
   * - orderBy->PLANNED_AT_ASC
   */
  webcasts: WebcastConnection;
};

export type QueryAssetUploadStatusArgs = {
  assetId: Scalars['ID']['input'];
};

export type QueryBlaStreamRoomArgs = {
  webcastId: Scalars['ID']['input'];
};

export type QueryCurrentUserRolesForWebcastArgs = {
  webcastId: Scalars['ID']['input'];
};

export type QueryIdentityProvidersArgs = {
  lsproId: Scalars['ID']['input'];
};

export type QueryLsproSettingsArgs = {
  lsproId: Scalars['ID']['input'];
};

export type QueryReportArgs = {
  reportType: ReportType;
  webcastId: Scalars['ID']['input'];
};

export type QueryReportMetadataArgs = {
  reportType: ReportType;
  webcastId: Scalars['ID']['input'];
};

export type QuerySessionArgs = {
  webcastId: Scalars['ID']['input'];
};

export type QueryStreamingUsageArgs = {
  lsproId: Scalars['ID']['input'];
};

export type QueryStreamingUsageReportArgs = {
  endDate: Scalars['DateTime']['input'];
  lsproId: Scalars['ID']['input'];
  startDate: Scalars['DateTime']['input'];
};

export type QueryUsersArgs = {
  lsproId: Scalars['ID']['input'];
};

export type QueryVideoArgs = {
  videoId: Scalars['ID']['input'];
  videoManagerId: Scalars['ID']['input'];
};

export type QueryVideoManagerArgs = {
  videoManagerId: Scalars['ID']['input'];
};

export type QueryVideosArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  channelId: Scalars['ID']['input'];
  first?: Scalars['Int']['input'];
  searchTerm?: InputMaybe<Scalars['String']['input']>;
  videoManagerId: Scalars['ID']['input'];
};

export type QueryWebcastArgs = {
  webcastId: Scalars['ID']['input'];
};

export type QueryWebcastsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<WebcastFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  lsproId: Scalars['ID']['input'];
  orderBy?: InputMaybe<WebcastOrder>;
  searchTerm?: InputMaybe<Scalars['String']['input']>;
};

export type Quota = {
  __typename?: 'Quota';
  type: QuotaType;
  value: Scalars['Int']['output'];
};

export enum QuotaType {
  IN_TOTAL = 'IN_TOTAL',
  PER_MONTH = 'PER_MONTH',
}

export type RecordingMetadata = {
  __typename?: 'RecordingMetadata';
  language?: Maybe<Scalars['String']['output']>;
};

export type RecordingSettings = {
  __typename?: 'RecordingSettings';
  enabled: Scalars['Boolean']['output'];
  videoManager?: Maybe<VideoManagerLink>;
};

export type RecordingSettingsInput = {
  enabled: Scalars['Boolean']['input'];
  videoManager?: InputMaybe<VideoManagerLinkInput>;
};

export enum RecordingState {
  OFF = 'OFF',
  ON = 'ON',
  UNKNOWN = 'UNKNOWN',
}

export enum RecordingUploadStatus {
  FAILED = 'FAILED',
  NOT_READY = 'NOT_READY',
  READY_FOR_DOWNLOAD = 'READY_FOR_DOWNLOAD',
}

export type ReferrerProtectionPolicy = {
  __typename?: 'ReferrerProtectionPolicy';
  /** List of referrer domains allowed to view the webcast */
  domains?: Maybe<Array<Scalars['String']['output']>>;
  /** Is Referrer Protection enabled */
  enabled: Scalars['Boolean']['output'];
};

export type RegistrationFormConfiguration = {
  __typename?: 'RegistrationFormConfiguration';
  bankCode?: Maybe<Scalars['Boolean']['output']>;
  companyName?: Maybe<Scalars['Boolean']['output']>;
  country?: Maybe<Scalars['Boolean']['output']>;
  departmentName?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['Boolean']['output']>;
  firstAndLastName?: Maybe<Scalars['Boolean']['output']>;
  jobTitle?: Maybe<Scalars['Boolean']['output']>;
  phoneNumber?: Maybe<Scalars['Boolean']['output']>;
  viewersPerDevice?: Maybe<Scalars['Boolean']['output']>;
};

export type RegistrationFormConfigurationInput = {
  bankCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyName?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['Boolean']['input']>;
  departmentName?: InputMaybe<Scalars['Boolean']['input']>;
  /** If true, users must fill out this field. */
  firstAndLastName?: InputMaybe<Scalars['Boolean']['input']>;
  jobTitle?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  viewersPerDevice?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RemoveUserInput = {
  id: Scalars['ID']['input'];
  lsproId: Scalars['ID']['input'];
};

export type RemoveUserResult = RemoveUserSuccess;

export type RemoveUserSuccess = {
  __typename?: 'RemoveUserSuccess';
  id: Scalars['ID']['output'];
};

export type Report = {
  __typename?: 'Report';
  downloadLink?: Maybe<Scalars['String']['output']>;
  generationFailure?: Maybe<ReportGenerationFailure>;
  id?: Maybe<Scalars['ID']['output']>;
  status: ReportStatus;
  type: ReportType;
  webcastId: Scalars['ID']['output'];
};

export enum ReportFailureCode {
  UNKNOWN_ERROR = 'UNKNOWN_ERROR',
}

export type ReportGenerationFailure = {
  __typename?: 'ReportGenerationFailure';
  code?: Maybe<ReportFailureCode>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type ReportMetadataResult = NotAuthorized | NotFound | Report;

export enum ReportStatus {
  CREATED = 'CREATED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  NO_DATA = 'NO_DATA',
  READY = 'READY',
  SCHEDULED = 'SCHEDULED',
}

export enum ReportType {
  CHAT_MESSAGES_REPORT = 'CHAT_MESSAGES_REPORT',
  REGISTERED_USERS_REPORT = 'REGISTERED_USERS_REPORT',
  VIEWS_REPORT = 'VIEWS_REPORT',
}

export type RevertVodSlideMarkersProblem = {
  __typename?: 'RevertVodSlideMarkersProblem';
  code: RevertVodSlideMarkersProblemCode;
};

export enum RevertVodSlideMarkersProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type RevertVodSlideMarkersResult = RevertVodSlideMarkersProblem | RevertVodSlideMarkersSuccess;

export type RevertVodSlideMarkersSuccess = {
  __typename?: 'RevertVodSlideMarkersSuccess';
  markers: Array<VodSlideMarker>;
};

export enum Role {
  ADMIN = 'ADMIN',
  DATA_ANALYST = 'DATA_ANALYST',
  EDITOR = 'EDITOR',
  MODERATOR = 'MODERATOR',
  PRODUCER = 'PRODUCER',
}

export type RtmpIngestInput = {
  parameters: RtmpParametersInput;
};

export type RtmpLiveStreamingDefaultParameters = {
  __typename?: 'RtmpLiveStreamingDefaultParameters';
  authenticationEnabled: Scalars['Boolean']['output'];
};

export type RtmpLiveStreamingParameters = {
  __typename?: 'RtmpLiveStreamingParameters';
  authenticationEnabled: Scalars['Boolean']['output'];
};

export type RtmpParametersInput = {
  /** When authentication is enabled, the rtmp username and password are required for streaming */
  authenticationEnabled?: Scalars['Boolean']['input'];
};

export type SsoBasedUserManagementFeature = LiveStreamProFeature & {
  __typename?: 'SSOBasedUserManagementFeature';
  enabled: Scalars['Boolean']['output'];
};

export type SaveBlaStreamRoomSettingsAsDefaultProblem = {
  __typename?: 'SaveBlaStreamRoomSettingsAsDefaultProblem';
  code: SaveBlaStreamRoomSettingsAsDefaultProblemCode;
};

export enum SaveBlaStreamRoomSettingsAsDefaultProblemCode {
  BLASTREAM_ROOM_WITH_SPECIFIED_WEBCAST_ID_DOESNT_EXIST = 'BLASTREAM_ROOM_WITH_SPECIFIED_WEBCAST_ID_DOESNT_EXIST',
}

export type SaveBlaStreamRoomSettingsAsDefaultResult =
  | SaveBlaStreamRoomSettingsAsDefaultProblem
  | SaveBlaStreamRoomSettingsAsDefaultSuccess;

export type SaveBlaStreamRoomSettingsAsDefaultSuccess = {
  __typename?: 'SaveBlaStreamRoomSettingsAsDefaultSuccess';
  _?: Maybe<Scalars['Int']['output']>;
};

export type SecurityPolicy =
  | AccessCodePolicy
  | EmailRegistrationPolicy
  | EmailWhitelistPolicy
  | ReferrerProtectionPolicy
  | SingleSignOnPolicy
  | TokenProtectionPolicy;

export type SecuritySettings = {
  __typename?: 'SecuritySettings';
  /** Shared secret for VMPro token protected videos */
  sharedSecretVmpro?: Maybe<Scalars['String']['output']>;
  /** Secret for generating HMAC tokens */
  tokenGenerationSecret: Scalars['String']['output'];
};

export type SetActiveSpeakersInput = {
  /** Speaker IDs to highlight, or empty list to clear the active speakers */
  speakerIds: Array<Scalars['ID']['input']>;
  /** Webcast ID */
  webcastId: Scalars['ID']['input'];
};

export type SetActiveSpeakersProblem = {
  __typename?: 'SetActiveSpeakersProblem';
  code: SetActiveSpeakersProblemCode;
};

export enum SetActiveSpeakersProblemCode {
  ALL_STREAMS_FAILED = 'ALL_STREAMS_FAILED',
  INVALID_WEBCAST_STATE = 'INVALID_WEBCAST_STATE',
  SPEAKER_NOT_FOUND = 'SPEAKER_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type SetActiveSpeakersResult = SetActiveSpeakersProblem | SetActiveSpeakersSuccess;

export type SetActiveSpeakersSuccess = {
  __typename?: 'SetActiveSpeakersSuccess';
  activeSpeakerIds: Array<Scalars['ID']['output']>;
  results: Array<StreamingOperationResult>;
};

export type SetDefaultThemeFailure = {
  __typename?: 'SetDefaultThemeFailure';
  code: SetDefaultThemeFailureCode;
};

export enum SetDefaultThemeFailureCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  THEME_NOT_FOUND = 'THEME_NOT_FOUND',
}

export type SetDefaultThemeInput = {
  /** ID of LSPro instance */
  lsproId: Scalars['ID']['input'];
  /** ID of the theme to be set as default */
  themeId: Scalars['ID']['input'];
};

export type SetDefaultThemeResult = SetDefaultThemeFailure | SetDefaultThemeSuccess;

export type SetDefaultThemeSuccess = {
  __typename?: 'SetDefaultThemeSuccess';
  theme: AppearanceTheme;
};

export type SetEventAccessPublicProblem = {
  __typename?: 'SetEventAccessPublicProblem';
  code: SetEventAccessPublicProblemCode;
};

export enum SetEventAccessPublicProblemCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_EDITABLE_STATE = 'WEBCAST_NOT_IN_EDITABLE_STATE',
}

export type SetEventAccessPublicResult = SetEventAccessPublicProblem | SetEventAccessPublicSuccess;

export type SetEventAccessPublicSuccess = {
  __typename?: 'SetEventAccessPublicSuccess';
  securityPolicies: Array<SecurityPolicy>;
};

export type SetUserRolesInput = {
  id: Scalars['ID']['input'];
  lsproId: Scalars['ID']['input'];
  roles: Array<Role>;
};

export type SetUserRolesProblem = {
  __typename?: 'SetUserRolesProblem';
  code: SetUserRolesProblemCode;
};

export enum SetUserRolesProblemCode {
  LSPRO_ROLE_LIMIT_EXCEEDED = 'LSPRO_ROLE_LIMIT_EXCEEDED',
  SSO_BASED_USER_MANAGEMENT_ENABLED = 'SSO_BASED_USER_MANAGEMENT_ENABLED',
}

export type SetUserRolesResult = SetUserRolesProblem | SetUserRolesSuccess;

export type SetUserRolesSuccess = {
  __typename?: 'SetUserRolesSuccess';
  user: User;
};

/** Webcast setup failed */
export type SetupWebcastProblem = {
  __typename?: 'SetupWebcastProblem';
  /** Code indicating the problem */
  code: SetupWebcastProblemCode;
};

export enum SetupWebcastProblemCode {
  INGEST_PROTOCOL_NOT_CHOSEN = 'INGEST_PROTOCOL_NOT_CHOSEN',
  WEBCAST_IS_LIVE = 'WEBCAST_IS_LIVE',
}

export type SetupWebcastResult = SetupWebcastProblem | SetupWebcastSuccess;

/** Webcast has been successfully configured */
export type SetupWebcastSuccess = {
  __typename?: 'SetupWebcastSuccess';
  webcast: Webcast;
};

export type SharingLink = {
  __typename?: 'SharingLink';
  sharingUrl: Scalars['String']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export type SingleSignOnPolicy = {
  __typename?: 'SingleSignOnPolicy';
  /** Is single sign-on enabled */
  enabled: Scalars['Boolean']['output'];
  /** List of IDPs for single sign-on */
  idps?: Maybe<Array<Scalars['String']['output']>>;
  /** Restrictions for single sign-on */
  restrictions?: Maybe<SingleSignOnRestrictions>;
  /**
   * Show watermarking for this webcast
   * Also false, if watermarking feature is not enabled for lspro
   */
  showWatermarking: Scalars['Boolean']['output'];
};

export type SingleSignOnRestrictions = {
  __typename?: 'SingleSignOnRestrictions';
  emailList: EmailListResult;
  emailTemplates: Array<Scalars['String']['output']>;
  emails: Array<Scalars['String']['output']>;
  employeeIds: Array<Scalars['String']['output']>;
  enabled: Scalars['Boolean']['output'];
  groups: Array<Scalars['String']['output']>;
};

export type Speaker = {
  __typename?: 'Speaker';
  /** Speaker identifier */
  id: Scalars['ID']['output'];
  /** Speaker full name */
  name: Scalars['String']['output'];
  /** Speaker picture asset */
  picture: Asset;
  /** Speaker position / job title */
  position: Scalars['String']['output'];
};

export type SrtIngestInput = {
  parameters: SrtParametersInput;
};

export type SrtLiveStreamingDefaultParameters = {
  __typename?: 'SrtLiveStreamingDefaultParameters';
  pids: Array<Pid>;
};

export type SrtLiveStreamingParameters = {
  __typename?: 'SrtLiveStreamingParameters';
  pids: Array<Pid>;
};

export type SrtParametersInput = {
  /** When set to null, default parameters are applied */
  pids?: InputMaybe<Array<PidInput>>;
};

export type StandardLanguage = {
  __typename?: 'StandardLanguage';
  code: Scalars['String']['output'];
};

export type StartEventNotEnoughStreamsConnectedProblem = {
  __typename?: 'StartEventNotEnoughStreamsConnectedProblem';
  unconnectedStreams: Array<Stream>;
};

export type StartEventProblem = {
  __typename?: 'StartEventProblem';
  /** Code indicating the problem */
  code: StartEventProblemCode;
};

export enum StartEventProblemCode {
  EVENT_NOT_INITIALIZED = 'EVENT_NOT_INITIALIZED',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type StartEventResult = StartEventNotEnoughStreamsConnectedProblem | StartEventProblem | StartEventSuccess;

export type StartEventSuccess = {
  __typename?: 'StartEventSuccess';
  results: Array<StreamingOperationResult>;
};

export type StartLiveTestProblem = {
  __typename?: 'StartLiveTestProblem';
  /** Code indicating the problem */
  code: StartLiveTestProblemCode;
};

export enum StartLiveTestProblemCode {
  EVENT_NOT_INITIALIZED = 'EVENT_NOT_INITIALIZED',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  NOT_ENOUGH_STREAMS_CONNECTED = 'NOT_ENOUGH_STREAMS_CONNECTED',
  /** deprecated */
  NO_STREAM_CONNECTED_ON_PRIMARY = 'NO_STREAM_CONNECTED_ON_PRIMARY',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type StartLiveTestResult = StartLiveTestProblem | StartLiveTestSuccess;

export type StartLiveTestSuccess = {
  __typename?: 'StartLiveTestSuccess';
  webcast: Webcast;
};

export enum State {
  ARCHIVED = 'ARCHIVED',
  INITIALIZING = 'INITIALIZING',
  LIVE = 'LIVE',
  LIVE_TEST = 'LIVE_TEST',
  POSTLIVE = 'POSTLIVE',
  PRELIVE = 'PRELIVE',
}

export enum StateFilter {
  /** webcasts in state ARCHIVED */
  ARCHIVED = 'ARCHIVED',
  /** webcasts in state POSTLIVE */
  ENDED = 'ENDED',
  /** webcasts in state LIVE_TEST or LIVE */
  LIVE = 'LIVE',
  /** webcasts in state POSTLIVE and Vod enabled */
  ON_DEMAND = 'ON_DEMAND',
  /** webcasts in state INITIALIZING or PRELIVE */
  PLANNED = 'PLANNED',
}

export type StopEventProblem = {
  __typename?: 'StopEventProblem';
  /** Code indicating the problem */
  code: StopEventProblemCode;
};

export enum StopEventProblemCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_LIVE_STATE = 'WEBCAST_NOT_IN_LIVE_STATE',
}

export type StopEventResult = StopEventProblem | StopEventSuccess;

export type StopEventSuccess = {
  __typename?: 'StopEventSuccess';
  results: Array<StreamingOperationResult>;
};

export type StopLiveTestProblem = {
  __typename?: 'StopLiveTestProblem';
  /** Code indicating the problem */
  code: StopLiveTestProblemCode;
};

export enum StopLiveTestProblemCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_LIVE_TEST_STATE = 'WEBCAST_NOT_IN_LIVE_TEST_STATE',
}

export type StopLiveTestResult = StopLiveTestProblem | StopLiveTestSuccess;

export type StopLiveTestSuccess = {
  __typename?: 'StopLiveTestSuccess';
  webcast: Webcast;
};

export type Storyboard = {
  __typename?: 'Storyboard';
  height: Scalars['Int']['output'];
  interval: Scalars['Int']['output'];
  sources: Array<Scalars['Url']['output']>;
  spritesPerRow: Scalars['Int']['output'];
  width: Scalars['Int']['output'];
};

export type Stream = {
  __typename?: 'Stream';
  /** AI live transcript editor settings if aiLiveTranscriptEditorEnabled is set */
  aiLiveTranscriptEditorSettings?: Maybe<AiLiveTranscriptEditorSettings>;
  /** Backup (ingested to "backupServer") stream state */
  backupStatus: StreamStatus;
  /** Configuration details needed to connect a video source to the live stream */
  ingest: Ingest;
  /** Other data used to identify live stream */
  metadata?: Maybe<StreamMetadata>;
  /** Configuration details needed to playback live stream */
  playback: Playback;
  /** Primary (ingested to "primaryServer") stream state */
  primaryStatus: StreamStatus;
  /**
   * Mode for selecting which source (primary or backup) is used for viewers
   * If not explicitly set, the default is `AUTO`.
   */
  viewerSourceMode: ViewerSourceMode;
};

export type StreamMetadata = {
  __typename?: 'StreamMetadata';
  language?: Maybe<Scalars['String']['output']>;
};

export type StreamMetadataInput = {
  language?: InputMaybe<Scalars['String']['input']>;
};

export type StreamRecording = {
  __typename?: 'StreamRecording';
  /** Download URL */
  downloadLink?: Maybe<Scalars['Url']['output']>;
  /** Metadata for the recording */
  metadata: RecordingMetadata;
  /** Status of recording processing */
  status: RecordingUploadStatus;
};

export enum StreamState {
  CONNECTED = 'CONNECTED',
  STARTED = 'STARTED',
  STARTING = 'STARTING',
  STOPPED = 'STOPPED',
  STOPPING = 'STOPPING',
  UNKNOWN = 'UNKNOWN',
}

export type StreamStatus = {
  __typename?: 'StreamStatus';
  playbackState: PlaybackState;
  recordingState: RecordingState;
  streamState: StreamState;
};

export type Streaming = {
  __typename?: 'Streaming';
  live?: Maybe<LiveStreaming>;
  recordings: Array<StreamRecording>;
  subtitles?: Maybe<SubtitlesResult>;
  vod?: Maybe<VodStreaming>;
};

export type StreamingOperationResult = {
  __typename?: 'StreamingOperationResult';
  backup: StreamingOperationStatus;
  metadata?: Maybe<StreamMetadata>;
  primary: StreamingOperationStatus;
};

export enum StreamingOperationStatus {
  FAILED = 'FAILED',
  OK = 'OK',
  SKIPPED = 'SKIPPED',
}

export type SubtitleGlossaryEntry = {
  __typename?: 'SubtitleGlossaryEntry';
  alternatePronunciations: Array<Scalars['String']['output']>;
  term: Scalars['String']['output'];
};

export type SubtitleGlossaryEntryInput = {
  alternatePronunciations: Array<Scalars['String']['input']>;
  term: Scalars['String']['input'];
};

export type SubtitleSettings = {
  __typename?: 'SubtitleSettings';
  aiLiveTranscriptEditorEnabled: Scalars['Boolean']['output'];
  aiLiveTranscriptGeneration: Scalars['Boolean']['output'];
  glossary: GlossaryResult;
  translationLanguages: Array<Scalars['String']['output']>;
};

export type SubtitleSettingsInput = {
  aiLiveTranscriptEditorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  aiLiveTranscriptGeneration?: InputMaybe<Scalars['Boolean']['input']>;
  glossary?: InputMaybe<GlossaryInput>;
  translationLanguages?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Subtitles = {
  __typename?: 'Subtitles';
  /** Download URL for zip file containing generated subtitles */
  downloadLink?: Maybe<Scalars['Url']['output']>;
  status: SubtitlesStatus;
};

export type SubtitlesResult = NotSupportedForThisQuery | Subtitles;

export enum SubtitlesStatus {
  FAILED = 'FAILED',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  NOT_READY = 'NOT_READY',
  READY_FOR_DOWNLOAD = 'READY_FOR_DOWNLOAD',
}

export enum TargetAudience {
  MANAGER = 'MANAGER',
  VIEWER = 'VIEWER',
}

export type TermsAndConditions = {
  __typename?: 'TermsAndConditions';
  content: Scalars['String']['output'];
  header?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  locale: Scalars['String']['output'];
  subheader?: Maybe<Scalars['String']['output']>;
};

export type TermsAndConditionsFeature = LiveStreamProFeature & {
  __typename?: 'TermsAndConditionsFeature';
  enabled: Scalars['Boolean']['output'];
  termsAndConditions: Array<TermsAndConditions>;
};

export type TermsAndConditionsInput = {
  content: Scalars['String']['input'];
  header?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
  subheader?: InputMaybe<Scalars['String']['input']>;
  targetAudience: TargetAudience;
};

export enum Theme {
  DARK = 'DARK',
  LIGHT = 'LIGHT',
}

export type TokenProtectionPolicy = {
  __typename?: 'TokenProtectionPolicy';
  /** Indicates if policy is enabled */
  enabled: Scalars['Boolean']['output'];
};

export type TranscodingProfile = {
  __typename?: 'TranscodingProfile';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  settings: TranscodingSettings;
};

export type TranscodingProfileSettings = {
  __typename?: 'TranscodingProfileSettings';
  customProfiles: Array<TranscodingProfile>;
  defaultProfileId: Scalars['ID']['output'];
};

export type TranscodingSettings = {
  __typename?: 'TranscodingSettings';
  description: Scalars['String']['output'];
  encodings: Array<Encoding>;
};

export type UnarchiveWebcastProblem = {
  __typename?: 'UnarchiveWebcastProblem';
  /** Code indicating the problem */
  code: UnarchiveWebcastProblemCode;
};

export enum UnarchiveWebcastProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type UnarchiveWebcastResult = UnarchiveWebcastProblem | UnarchiveWebcastSuccess;

export type UnarchiveWebcastSuccess = {
  __typename?: 'UnarchiveWebcastSuccess';
  webcast: Webcast;
};

export type UnmoderatedChatSettings = ChatSettings & {
  __typename?: 'UnmoderatedChatSettings';
  allowBeforeLive: Scalars['Boolean']['output'];
  type: ChatType;
  useProvidedUsername: Scalars['Boolean']['output'];
};

export type UpdateAccessCodePolicyInput = {
  /**
   * Access code.
   * Must be between 6 and 30 characters long,
   * containing only letters (upper and lowercase),
   * digits, and special characters (_!#+=?@$&*-), with no spaces
   */
  accessCode?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if policy is enabled */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webcast ID given policy will be associated with */
  webcastId: Scalars['ID']['input'];
};

/** Update access code policy has failed */
export type UpdateAccessCodePolicyProblem = {
  __typename?: 'UpdateAccessCodePolicyProblem';
  /** Code indicating the problem */
  code: UpdateAccessCodePolicyProblemCode;
};

export enum UpdateAccessCodePolicyProblemCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_EDITABLE_STATE = 'WEBCAST_NOT_IN_EDITABLE_STATE',
  /** @deprecated Use WEBCAST_NOT_IN_EDITABLE_STATE instead */
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type UpdateAccessCodePolicyResult =
  | UpdateAccessCodePolicyProblem
  | UpdateAccessCodePolicySuccess
  | ValidationErrors;

/** Access code policy has been successfully updated */
export type UpdateAccessCodePolicySuccess = {
  __typename?: 'UpdateAccessCodePolicySuccess';
  /** Access code policy */
  accessCodePolicy: AccessCodePolicy;
};

export type UpdateAiSubtitlesFeatureInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateAppearanceSettingsFailure = {
  __typename?: 'UpdateAppearanceSettingsFailure';
  code?: Maybe<UpdateAppearanceSettingsFailureCode>;
};

export enum UpdateAppearanceSettingsFailureCode {
  INVALID_HEX_COLOR = 'INVALID_HEX_COLOR',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  UNSUPPORTED_FONT = 'UNSUPPORTED_FONT',
}

export type UpdateAppearanceSettingsInput = {
  appearanceColors?: InputMaybe<Array<InputMaybe<AppearanceColorsInput>>>;
  customFont?: InputMaybe<CustomFontInput>;
  fonts?: InputMaybe<AppearanceFontsInput>;
  lsproId: Scalars['String']['input'];
  /** @deprecated Use appearanceColors instead */
  primaryColor?: InputMaybe<Scalars['String']['input']>;
  theme?: InputMaybe<Theme>;
};

export type UpdateAppearanceSettingsResult = UpdateAppearanceSettingsFailure | UpdateAppearanceSettingsSuccess;

export type UpdateAppearanceSettingsSuccess = {
  __typename?: 'UpdateAppearanceSettingsSuccess';
  appearanceSettings: AppearanceSettings;
};

export type UpdateBrowserBasedStudioFeatureInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateChatInput = {
  allowBeforeLive?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<ChatType>;
  useProvidedUsername?: InputMaybe<Scalars['Boolean']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type UpdateChatProblem = {
  __typename?: 'UpdateChatProblem';
  code: UpdateChatProblemCode;
};

export enum UpdateChatProblemCode {
  WEBCAST_HAS_CHAT_DISABLED = 'WEBCAST_HAS_CHAT_DISABLED',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type UpdateChatResult = UpdateChatProblem | UpdateChatSuccess;

export type UpdateChatSuccess = {
  __typename?: 'UpdateChatSuccess';
  allowBeforeLive: Scalars['Boolean']['output'];
  type: ChatType;
  useProvidedUsername: Scalars['Boolean']['output'];
  webcastId: Scalars['ID']['output'];
};

export type UpdateComplianceFormFailure = {
  __typename?: 'UpdateComplianceFormFailure';
  code?: Maybe<UpdateComplianceFormFailureCode>;
};

export enum UpdateComplianceFormFailureCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type UpdateComplianceFormInput = {
  complianceForm?: InputMaybe<ComplianceFormInput>;
  includeDefaultComplianceForm?: InputMaybe<Scalars['Boolean']['input']>;
  lsproId: Scalars['String']['input'];
};

export type UpdateComplianceFormResult = UpdateComplianceFormFailure | UpdateComplianceFormSuccess;

export type UpdateComplianceFormSuccess = {
  __typename?: 'UpdateComplianceFormSuccess';
  complianceForm: ComplianceForm;
  includeDefaultComplianceForm: Scalars['Boolean']['output'];
};

export type UpdateComplianceSettingsFailure = {
  __typename?: 'UpdateComplianceSettingsFailure';
  code: UpdateComplianceSettingsFailureCode;
};

export enum UpdateComplianceSettingsFailureCode {
  LANGUAGE_NOT_SUPPORTED = 'LANGUAGE_NOT_SUPPORTED',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type UpdateComplianceSettingsInput = {
  /**
   * Localized compliance links and data protection text.
   * Set to null value to keep the current data.
   */
  complianceSettingsForm?: InputMaybe<ComplianceSettingsFormInput>;
  /**
   * A flag indicating whether user wants to display movingimage compliance links or not.
   * Set to null value to keep the current setting.
   */
  includeDefaultComplianceForm?: InputMaybe<Scalars['Boolean']['input']>;
  lsproId: Scalars['ID']['input'];
};

export type UpdateComplianceSettingsResult = UpdateComplianceSettingsFailure | UpdateComplianceSettingsSuccess;

export type UpdateComplianceSettingsSuccess = {
  __typename?: 'UpdateComplianceSettingsSuccess';
  complianceForm: ComplianceForm;
  dataProtectionForm: DataProtectionForm;
  includeDefaultComplianceForm: Scalars['Boolean']['output'];
};

export type UpdateCustomDomainsFeatureInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
  customDomains: CustomDomainsInput;
};

export type UpdateCustomVodManifestUrlFeatureInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateDataProtectionFormFailure = {
  __typename?: 'UpdateDataProtectionFormFailure';
  code?: Maybe<UpdateDataProtectionFormFailureCode>;
};

export enum UpdateDataProtectionFormFailureCode {
  LANGUAGE_NOT_SUPPORTED = 'LANGUAGE_NOT_SUPPORTED',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type UpdateDataProtectionFormInput = {
  entries: Array<UpdateLocalizedDataProtectionEntryInput>;
  lsproId: Scalars['String']['input'];
};

export type UpdateDataProtectionFormResult = UpdateDataProtectionFormFailure | UpdateDataProtectionFormSuccess;

export type UpdateDataProtectionFormSuccess = {
  __typename?: 'UpdateDataProtectionFormSuccess';
  dataProtectionForm: DataProtectionForm;
};

export type UpdateDefaultTranscodingProfileFailure = {
  __typename?: 'UpdateDefaultTranscodingProfileFailure';
  code: UpdateDefaultTranscodingProfileFailureCode;
};

export enum UpdateDefaultTranscodingProfileFailureCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  PROFILE_NOT_FOUND = 'PROFILE_NOT_FOUND',
}

export type UpdateDefaultTranscodingProfileInput = {
  defaultProfileId: Scalars['ID']['input'];
  lsproId: Scalars['String']['input'];
};

export type UpdateDefaultTranscodingProfileResult =
  | UpdateDefaultTranscodingProfileFailure
  | UpdateDefaultTranscodingProfileSuccess;

export type UpdateDefaultTranscodingProfileSuccess = {
  __typename?: 'UpdateDefaultTranscodingProfileSuccess';
  defaultProfile: TranscodingProfile;
};

export type UpdateEmailItemsInput = {
  /** Action enum (ADD or REMOVE). */
  action: ItemListAction;
  /**
   * List of emails that should either be added or removed.
   * Email templates with wildcard symbol (*) are supported.
   * Items should follow valid email format. Otherwise UpdateEmailWhitelistPolicyEmailValidationFailure will be returned.
   * Items are transformed to lower case and duplicates are removed.
   */
  items: Array<Scalars['String']['input']>;
};

export type UpdateEmailRegistrationPolicyFailure = {
  __typename?: 'UpdateEmailRegistrationPolicyFailure';
  code: UpdateEmailRegistrationPolicyFailureCode;
};

export enum UpdateEmailRegistrationPolicyFailureCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_EDITABLE_STATE = 'WEBCAST_NOT_IN_EDITABLE_STATE',
  /** @deprecated Use WEBCAST_NOT_IN_EDITABLE_STATE instead */
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type UpdateEmailRegistrationPolicyInput = {
  /** Indicates if policy is enabled */
  enabled: Scalars['Boolean']['input'];
  /**
   * Registration form configuration.
   * Set to null value to keep the current value.
   */
  registrationFormConfigurationInput?: InputMaybe<RegistrationFormConfigurationInput>;
  /**
   * If true, requires that users verify their email address by entering a code sent to their email
   * Set to null value to keep the current value.
   * @deprecated Use mutation requireEmailVerification instead
   */
  requireEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webcast ID this policy applies for */
  webcastId: Scalars['ID']['input'];
};

export type UpdateEmailRegistrationPolicyResult =
  | UpdateEmailRegistrationPolicyFailure
  | UpdateEmailRegistrationPolicySuccess;

export type UpdateEmailRegistrationPolicySuccess = {
  __typename?: 'UpdateEmailRegistrationPolicySuccess';
  policy: EmailRegistrationPolicy;
};

export type UpdateEmailVerificationInput = {
  requireEmailVerification: Scalars['Boolean']['input'];
  webcastId: Scalars['ID']['input'];
};

export type UpdateEmailVerificationProblem = {
  __typename?: 'UpdateEmailVerificationProblem';
  code: UpdateEmailVerificationProblemCode;
};

export enum UpdateEmailVerificationProblemCode {
  NO_EMAIL_BASED_POLICY_ENABLED = 'NO_EMAIL_BASED_POLICY_ENABLED',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_EDITABLE_STATE = 'WEBCAST_NOT_IN_EDITABLE_STATE',
}

export type UpdateEmailVerificationResult = UpdateEmailVerificationProblem | UpdateEmailVerificationSuccess;

export type UpdateEmailVerificationSuccess = {
  __typename?: 'UpdateEmailVerificationSuccess';
  securityPolicies: Array<SecurityPolicy>;
};

export type UpdateEmailWhitelistPolicyEmailValidationFailure = {
  __typename?: 'UpdateEmailWhitelistPolicyEmailValidationFailure';
  invalidEmails: Array<Scalars['String']['output']>;
};

export enum UpdateEmailWhitelistPolicyFailureCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_EDITABLE_STATE = 'WEBCAST_NOT_IN_EDITABLE_STATE',
  /** @deprecated Use WEBCAST_NOT_IN_EDITABLE_STATE instead */
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type UpdateEmailWhitelistPolicyGenericFailure = {
  __typename?: 'UpdateEmailWhitelistPolicyGenericFailure';
  code: UpdateEmailWhitelistPolicyFailureCode;
};

export type UpdateEmailWhitelistPolicyInput = {
  /**
   * List of modifications that will be applied to current email list.
   * Set to null value to keep the current value.
   */
  emails?: InputMaybe<Array<UpdateEmailItemsInput>>;
  /**
   * Is policy enabled.
   * Set to null value to keep the current value.
   */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Registration form configuration.
   * Set to null value to keep the current value.
   * @deprecated Use EmailRegistrationPolicy.registrationFormConfiguration instead
   */
  registrationFormConfigurationInput?: InputMaybe<RegistrationFormConfigurationInput>;
  /**
   * If true, requires that users verify their email address by entering a code sent to their email
   * Set to null value to keep the current value.
   * @deprecated Use mutation requireEmailVerification instead
   */
  requireEmailVerification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webcast ID this policy applies for */
  webcastId: Scalars['ID']['input'];
};

export type UpdateEmailWhitelistPolicyResult =
  | UpdateEmailWhitelistPolicyEmailValidationFailure
  | UpdateEmailWhitelistPolicyGenericFailure
  | UpdateEmailWhitelistPolicySuccess;

export type UpdateEmailWhitelistPolicySuccess = {
  __typename?: 'UpdateEmailWhitelistPolicySuccess';
  policy: EmailWhitelistPolicy;
};

export type UpdateEventPermissionInput = {
  /**
   * List of modifications that will be applied to collaborators list.
   * Set to null value to keep the current value.
   */
  collaborators?: InputMaybe<Array<UpdateUserIdItemsInput>>;
  /**
   * List of modifications that will be applied to moderators list.
   * Set to null value to keep the current value.
   */
  moderators?: InputMaybe<Array<UpdateUserIdItemsInput>>;
  /**
   * List of modifications that will be applied to owners list.
   * Set to null value to keep the current value.
   */
  owners?: InputMaybe<Array<UpdateUserIdItemsInput>>;
  /**
   * event type
   * Set to null value to keep the current value.
   */
  type?: InputMaybe<EventPermissionType>;
  /** Webcast ID this EventPermission applies for */
  webcastId: Scalars['ID']['input'];
};

export type UpdateEventPermissionProblem = {
  __typename?: 'UpdateEventPermissionProblem';
  /** Code indicating the problem */
  code: UpdateEventPermissionProblemCode;
};

export enum UpdateEventPermissionProblemCode {
  AT_LEAST_ONE_OWNER_REQUIRED = 'AT_LEAST_ONE_OWNER_REQUIRED',
  INVALID_USER_EVENT_PERMISSION_ASSIGNMENT = 'INVALID_USER_EVENT_PERMISSION_ASSIGNMENT',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type UpdateEventPermissionResult =
  | UpdateEventPermissionProblem
  | UpdateEventPermissionSuccess
  | UpdateEventPermissionValidationFailure;

export type UpdateEventPermissionSuccess = {
  __typename?: 'UpdateEventPermissionSuccess';
  /** Event permission */
  eventPermission: EventPermission;
};

export type UpdateEventPermissionValidationFailure = {
  __typename?: 'UpdateEventPermissionValidationFailure';
  invalidCollaborators: Array<Scalars['String']['output']>;
  invalidModerators: Array<Scalars['String']['output']>;
  invalidOwners: Array<Scalars['String']['output']>;
};

export type UpdateEventStartVerificationPolicyFailure = {
  __typename?: 'UpdateEventStartVerificationPolicyFailure';
  code?: Maybe<UpdateEventStartVerificationPolicyFailureCode>;
};

export enum UpdateEventStartVerificationPolicyFailureCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type UpdateEventStartVerificationPolicyInput = {
  lsproId: Scalars['String']['input'];
  policy: EventStartVerificationPolicy;
};

export type UpdateEventStartVerificationPolicyResult =
  | UpdateEventStartVerificationPolicyFailure
  | UpdateEventStartVerificationPolicySuccess;

export type UpdateEventStartVerificationPolicySuccess = {
  __typename?: 'UpdateEventStartVerificationPolicySuccess';
  policy: EventStartVerificationPolicy;
};

export type UpdateFontInput = {
  fontId: Scalars['ID']['input'];
  /** ID of LSPro instance this font will be visible in */
  lsproId: Scalars['ID']['input'];
  /** Display name of custom font */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateFontProblem = {
  __typename?: 'UpdateFontProblem';
  code: UpdateFontProblemCode;
};

export enum UpdateFontProblemCode {
  FONT_NOT_FOUND = 'FONT_NOT_FOUND',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type UpdateFontResult = UpdateFontProblem | UpdateFontSuccess;

export type UpdateFontSuccess = {
  __typename?: 'UpdateFontSuccess';
  fontId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UpdateLiveStreamProDefaultSettingsFailure = {
  __typename?: 'UpdateLiveStreamProDefaultSettingsFailure';
  code?: Maybe<UpdateLiveStreamProDefaultSettingsFailureCode>;
};

export enum UpdateLiveStreamProDefaultSettingsFailureCode {
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  MULTIPLE_INGEST_SETTINGS_PROVIDED = 'MULTIPLE_INGEST_SETTINGS_PROVIDED',
  WATERMARKING_FEATURE_NOT_ENABLED = 'WATERMARKING_FEATURE_NOT_ENABLED',
}

export type UpdateLiveStreamProDefaultSettingsInput = {
  allowTranscodingProfileSelection?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Default ingest settings for new webcasts.
   * When provided, this takes precedence over ingestAuthenticationAsDefault.
   * Provide exactly one of srt or rtmp.
   */
  defaultIngestSettings?: InputMaybe<DefaultIngestSettingsInput>;
  /** @deprecated Use defaultIngestSettings instead */
  ingestAuthenticationAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  lsproId: Scalars['ID']['input'];
  privateEventAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  restrictAttendanceReport?: InputMaybe<Scalars['Boolean']['input']>;
  showWatermarkingAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
  singleSignOnAsDefault?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateLiveStreamProDefaultSettingsResult =
  | UpdateLiveStreamProDefaultSettingsFailure
  | UpdateLiveStreamProDefaultSettingsSuccess;

export type UpdateLiveStreamProDefaultSettingsSuccess = {
  __typename?: 'UpdateLiveStreamProDefaultSettingsSuccess';
  defaultSettings: LiveStreamProDefaultSettings;
};

export type UpdateLiveStreamProFeatureInput = {
  /**  or  */
  aiSubtitlesFeature?: InputMaybe<UpdateAiSubtitlesFeatureInput>;
  /**  or  */
  browserBasedStudioFeature?: InputMaybe<UpdateBrowserBasedStudioFeatureInput>;
  /**  or  */
  customDomainsFeature?: InputMaybe<UpdateCustomDomainsFeatureInput>;
  /**  or  */
  customVodManifestUrlFeature?: InputMaybe<UpdateCustomVodManifestUrlFeatureInput>;
  /** Indicates whether the feature is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Indicates the feature type */
  featureType: LiveStreamProFeatureType;
  /**
   * One and only one of the following fields should be set depending on featureType.
   * Other values will be discarded.
   * The error is returned if the corresponding field is not set.
   *
   * todo: Consider using @oneOf GraphQL directive once it's officially supported
   *       (https://github.com/graphql/graphql-spec/pull/825)
   */
  liveStreamingHoursFeature?: InputMaybe<UpdateLiveStreamingHoursFeatureInput>;
  /**  or  */
  ssoBasedUserManagementFeature?: InputMaybe<UpdateSsoBasedUserManagementFeatureInput>;
  /**  or  */
  termsAndConditionsFeature?: InputMaybe<UpdateTermsAndConditionsFeatureInput>;
  /**  or  */
  watermarkingFeature?: InputMaybe<UpdateWatermarkingFeatureInput>;
};

export type UpdateLiveStreamProInput = {
  features?: InputMaybe<Array<UpdateLiveStreamProFeatureInput>>;
  lsproId: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLiveStreamProSecuritySettingsFailure = {
  __typename?: 'UpdateLiveStreamProSecuritySettingsFailure';
  code?: Maybe<UpdateLiveStreamProSecuritySettingsFailureCode>;
};

export enum UpdateLiveStreamProSecuritySettingsFailureCode {
  INVALID_SHARED_SECRET_VMPRO = 'INVALID_SHARED_SECRET_VMPRO',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
}

export type UpdateLiveStreamProSecuritySettingsInput = {
  lsproId: Scalars['ID']['input'];
  /**
   * Shared secret for generating HMAC token for token protected videos of VMPro
   * Set to blank value to delete shared secret.
   * Set to null value to keep the current value.
   */
  sharedSecretVmpro?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateLiveStreamProSecuritySettingsResult =
  | UpdateLiveStreamProSecuritySettingsFailure
  | UpdateLiveStreamProSecuritySettingsSuccess;

export type UpdateLiveStreamProSecuritySettingsSuccess = {
  __typename?: 'UpdateLiveStreamProSecuritySettingsSuccess';
  sharedSecretVmpro?: Maybe<Scalars['String']['output']>;
};

export type UpdateLiveStreamingHoursFeatureInput = {
  quotaType: QuotaType;
  value: Scalars['Int']['input'];
};

export type UpdateLocalizedDataProtectionEntryInput = {
  language: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

/** Update of the Referrer Protection has failed */
export type UpdateReferrerProtectionPolicyFailure = {
  __typename?: 'UpdateReferrerProtectionPolicyFailure';
  /** Code indicating the problem */
  code: UpdateReferrerProtectionPolicyFailureCode;
};

export enum UpdateReferrerProtectionPolicyFailureCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_EDITABLE_STATE = 'WEBCAST_NOT_IN_EDITABLE_STATE',
  /** @deprecated Use WEBCAST_NOT_IN_EDITABLE_STATE instead */
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type UpdateReferrerProtectionPolicyInput = {
  /** List of referrer domains allowed to view the webcast */
  domains?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Flag for enabling/disabling Referrer Protection */
  enabled: Scalars['Boolean']['input'];
  /** Webcast ID Referrer Protection will be enabled for */
  webcastId: Scalars['ID']['input'];
};

/** Referrer Protection has been successfully updated */
export type UpdateReferrerProtectionPolicySuccess = {
  __typename?: 'UpdateReferrerProtectionPolicySuccess';
  /** Referrer protection configuration */
  referrerProtectionPolicy: ReferrerProtectionPolicy;
};

export type UpdateReferrerProtectionResult =
  | UpdateReferrerProtectionPolicyFailure
  | UpdateReferrerProtectionPolicySuccess;

export type UpdateSsoBasedUserManagementFeatureInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateSingleSignOnEmployeeIdItemsInput = {
  /** Action enum (ADD or REMOVE). */
  action: ItemListAction;
  /**
   * List of employee ids that should either be added or removed.
   * Items are stored case sensitive and duplicates are removed.
   */
  items: Array<Scalars['String']['input']>;
};

export type UpdateSingleSignOnGroupItemsInput = {
  /** Action enum (ADD or REMOVE). */
  action: ItemListAction;
  /**
   * List of groups that should either be added or removed.
   * Items are stored case sensitive and duplicates are removed.
   */
  items: Array<Scalars['String']['input']>;
};

export enum UpdateSingleSignOnPolicyFailureCode {
  IDP_LIST_EMPTY = 'IDP_LIST_EMPTY',
  WATERMARKING_FEATURE_NOT_ENABLED = 'WATERMARKING_FEATURE_NOT_ENABLED',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_EDITABLE_STATE = 'WEBCAST_NOT_IN_EDITABLE_STATE',
  /** @deprecated Use WEBCAST_NOT_IN_EDITABLE_STATE instead */
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type UpdateSingleSignOnPolicyGenericFailure = {
  __typename?: 'UpdateSingleSignOnPolicyGenericFailure';
  code: UpdateSingleSignOnPolicyFailureCode;
};

export type UpdateSingleSignOnPolicyInput = {
  /**
   * List of modifications that will be applied to current email list.
   * Set to null value to keep the current value.
   */
  emails?: InputMaybe<Array<UpdateEmailItemsInput>>;
  /**
   * List of modifications that will be applied to current employee id list.
   * Set to null value to keep the current value.
   */
  employeeIds?: InputMaybe<Array<UpdateSingleSignOnEmployeeIdItemsInput>>;
  /**
   * Is policy enabled.
   * Set to null value to keep the current value.
   */
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * List of modifications that will be applied to current group list.
   * Set to null value to keep the current value.
   */
  groups?: InputMaybe<Array<UpdateSingleSignOnGroupItemsInput>>;
  /**
   * List of IDPs for single sign-on
   * Set to null value to keep the current value.
   */
  idps?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Are restrictions (i.e. emails, employeeIds, groups) enabled
   * Set to null value to keep the current value.
   */
  restrictionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Show watermarking for this webcast
   * Set to null value to keep the current value.
   */
  showWatermarking?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webcast ID this policy applies for */
  webcastId: Scalars['ID']['input'];
};

export type UpdateSingleSignOnPolicyResult =
  | UpdateSingleSignOnPolicyGenericFailure
  | UpdateSingleSignOnPolicySuccess
  | UpdateSingleSignOnPolicyValidationFailure;

export type UpdateSingleSignOnPolicySuccess = {
  __typename?: 'UpdateSingleSignOnPolicySuccess';
  policy: SingleSignOnPolicy;
};

export type UpdateSingleSignOnPolicyValidationFailure = {
  __typename?: 'UpdateSingleSignOnPolicyValidationFailure';
  invalidEmails: Array<Scalars['String']['output']>;
};

export type UpdateSpeakerInput = {
  /** Updated speaker name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Updated picture asset ID (must be previously uploaded via createPicture) */
  pictureAssetId?: InputMaybe<Scalars['ID']['input']>;
  /** Updated speaker position / job title */
  position?: InputMaybe<Scalars['String']['input']>;
  speakerId: Scalars['ID']['input'];
  webcastId: Scalars['ID']['input'];
};

export type UpdateSpeakerProblem = {
  __typename?: 'UpdateSpeakerProblem';
  code: UpdateSpeakerProblemCode;
};

export enum UpdateSpeakerProblemCode {
  PICTURE_ALREADY_IN_USE = 'PICTURE_ALREADY_IN_USE',
  PICTURE_NOT_FOUND = 'PICTURE_NOT_FOUND',
  PICTURE_NOT_UPLOADED = 'PICTURE_NOT_UPLOADED',
  SPEAKER_NOT_FOUND = 'SPEAKER_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type UpdateSpeakerResult = UpdateSpeakerProblem | UpdateSpeakerSuccess;

export type UpdateSpeakerSuccess = {
  __typename?: 'UpdateSpeakerSuccess';
  speaker: Speaker;
};

export type UpdateStreamViewerSourceInput = {
  language: Scalars['String']['input'];
  mode: ViewerSourceMode;
  webcastId: Scalars['ID']['input'];
};

export type UpdateStreamViewerSourceProblem = {
  __typename?: 'UpdateStreamViewerSourceProblem';
  code: UpdateStreamViewerSourceProblemCode;
};

export enum UpdateStreamViewerSourceProblemCode {
  EVENT_NOT_INITIALIZED = 'EVENT_NOT_INITIALIZED',
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  LANGUAGE_NOT_FOUND = 'LANGUAGE_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type UpdateStreamViewerSourceResult = UpdateStreamViewerSourceProblem | UpdateStreamViewerSourceSuccess;

export type UpdateStreamViewerSourceSuccess = {
  __typename?: 'UpdateStreamViewerSourceSuccess';
  language: Scalars['String']['output'];
  mode: ViewerSourceMode;
};

export type UpdateTermsAndConditionsFeatureInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
  termsAndConditions: Array<TermsAndConditionsInput>;
};

export type UpdateThemeFailure = {
  __typename?: 'UpdateThemeFailure';
  code: UpdateThemeFailureCode;
};

export enum UpdateThemeFailureCode {
  INVALID_HEX_FORMAT = 'INVALID_HEX_FORMAT',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  THEME_NAME_ALREADY_EXISTS = 'THEME_NAME_ALREADY_EXISTS',
  THEME_NOT_FOUND = 'THEME_NOT_FOUND',
  UNSUPPORTED_FONT = 'UNSUPPORTED_FONT',
}

export type UpdateThemeInput = {
  /** Color scheme settings */
  appearanceColors?: InputMaybe<Array<AppearanceColorsInput>>;
  fonts?: InputMaybe<AppearanceFontsInput>;
  /** ID of LSPro instance */
  lsproId: Scalars['ID']['input'];
  /** Active mode */
  mode?: InputMaybe<Theme>;
  /** New name of the theme */
  name?: InputMaybe<Scalars['String']['input']>;
  /** ID of the theme to be updated */
  themeId: Scalars['ID']['input'];
};

export type UpdateThemeResult = UpdateThemeFailure | UpdateThemeSuccess;

export type UpdateThemeSuccess = {
  __typename?: 'UpdateThemeSuccess';
  theme: AppearanceTheme;
};

export type UpdateTokenProtectionFailure = {
  __typename?: 'UpdateTokenProtectionFailure';
  code: UpdateTokenProtectionFailureCode;
};

export enum UpdateTokenProtectionFailureCode {
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_EDITABLE_STATE = 'WEBCAST_NOT_IN_EDITABLE_STATE',
  /** @deprecated Use WEBCAST_NOT_IN_EDITABLE_STATE instead */
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type UpdateTokenProtectionPolicyInput = {
  /** Indicates if policy is enabled */
  enabled: Scalars['Boolean']['input'];
  /** Webcast ID this policy applies for */
  webcastId: Scalars['ID']['input'];
};

export type UpdateTokenProtectionResult = UpdateTokenProtectionFailure | UpdateTokenProtectionSuccess;

export type UpdateTokenProtectionSuccess = {
  __typename?: 'UpdateTokenProtectionSuccess';
  policy: TokenProtectionPolicy;
};

export type UpdateUserIdItemsInput = {
  /** Action enum (ADD or REMOVE). */
  action: ItemListAction;
  /** List of user ids that should either be added or removed. */
  items: Array<Scalars['String']['input']>;
};

export type UpdateVodInput = {
  language: Scalars['String']['input'];
  offsetInSeconds?: InputMaybe<Scalars['Int']['input']>;
  video?: InputMaybe<VideoReferenceInput>;
  videoVodManifestUrl?: InputMaybe<UrlInput>;
  webcastId: Scalars['ID']['input'];
};

export type UpdateVodProblem = {
  __typename?: 'UpdateVodProblem';
  code?: Maybe<UpdateVodProblemCode>;
};

export enum UpdateVodProblemCode {
  CUSTOM_VOD_MANIFEST_URL_FEATURE_NOT_ENABLED = 'CUSTOM_VOD_MANIFEST_URL_FEATURE_NOT_ENABLED',
  INVALID_VIDEO_CONFIGURATION_PROVIDED = 'INVALID_VIDEO_CONFIGURATION_PROVIDED',
  LANGUAGE_NOT_CONFIGURED = 'LANGUAGE_NOT_CONFIGURED',
  LANGUAGE_NOT_SUPPORTED = 'LANGUAGE_NOT_SUPPORTED',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
  WEBCAST_NOT_IN_POSTLIVE_STATE = 'WEBCAST_NOT_IN_POSTLIVE_STATE',
}

export type UpdateVodResult = UpdateVodProblem | UpdateVodSuccess;

export type UpdateVodSlideMarkersInput = {
  markerIds: Array<Scalars['ID']['input']>;
  offsetsInMs: Array<Scalars['Long']['input']>;
  webcastId: Scalars['ID']['input'];
};

export type UpdateVodSlideMarkersProblem = {
  __typename?: 'UpdateVodSlideMarkersProblem';
  code: UpdateVodSlideMarkersProblemCode;
};

export enum UpdateVodSlideMarkersProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  ID_AND_OFFSET_LISTS_DONT_MATCH = 'ID_AND_OFFSET_LISTS_DONT_MATCH',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  MARKERS_OUT_OF_ORDER = 'MARKERS_OUT_OF_ORDER',
  MARKER_NOT_FOUND = 'MARKER_NOT_FOUND',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type UpdateVodSlideMarkersResult = UpdateVodSlideMarkersProblem | UpdateVodSlideMarkersSuccess;

export type UpdateVodSlideMarkersSuccess = {
  __typename?: 'UpdateVodSlideMarkersSuccess';
  markers: Array<VodSlideMarker>;
};

export type UpdateVodSuccess = {
  __typename?: 'UpdateVodSuccess';
  language: Scalars['String']['output'];
  offsetInSeconds: Scalars['Int']['output'];
  reference?: Maybe<VideoReference>;
  videoVodManifestUrl?: Maybe<Scalars['Url']['output']>;
};

export type UpdateWatermarkingFeatureInput = {
  _?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateWebcastInput = {
  /** When true, the webcast is audio only (no video) */
  audioOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webcast media content for languages */
  contents?: InputMaybe<Array<WebcastContentInput>>;
  /** Planned duration of the webcast event in minutes. Set to 0 if planned duration is not known */
  durationInMinutes?: InputMaybe<Scalars['Int']['input']>;
  /** E-Cdn settings */
  ecdnSettings?: InputMaybe<ECdnSettingsInput>;
  /** When true, the event planned start time and duration are not displayed for viewers */
  hideWebcastScheduleInViewer?: InputMaybe<Scalars['Boolean']['input']>;
  /** Webcast ID */
  id: Scalars['ID']['input'];
  /** Ingest input */
  ingest?: InputMaybe<IngestInput>;
  /**
   * Type of protocol for ingestion
   * @deprecated Use ingest field instead
   */
  ingestProtocol?: InputMaybe<IngestProtocol>;
  /** Language input to modify configured languages */
  languages?: InputMaybe<Array<LanguageConfigurationInput>>;
  /** Webcast event name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Planned start date and time (ISO 8601) */
  plannedStartAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Recording settings */
  recordingSettings?: InputMaybe<RecordingSettingsInput>;
  /** Subtitles settings */
  subtitleSettings?: InputMaybe<SubtitleSettingsInput>;
  /** Theme for the event */
  themeId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Transcoding profile id
   * Null means keep current value
   */
  transcodingProfileId?: InputMaybe<Scalars['String']['input']>;
};

/** Webcast update failed */
export type UpdateWebcastProblem = {
  __typename?: 'UpdateWebcastProblem';
  /** Code indicating the problem */
  code: UpdateWebcastProblemCode;
};

export enum UpdateWebcastProblemCode {
  AI_SUBTITLES_LSPRO_FEATURE_NOT_ENABLED = 'AI_SUBTITLES_LSPRO_FEATURE_NOT_ENABLED',
  CONTENT_LANGUAGE_NOT_EXISTENT = 'CONTENT_LANGUAGE_NOT_EXISTENT',
  CUSTOM_VOD_MANIFEST_URL_FEATURE_NOT_ENABLED = 'CUSTOM_VOD_MANIFEST_URL_FEATURE_NOT_ENABLED',
  /** Max 1000 entries per request */
  GLOSSARY_SIZE_EXCEEDS_LIMIT = 'GLOSSARY_SIZE_EXCEEDS_LIMIT',
  INCORRECT_NUMBER_OF_PIDS = 'INCORRECT_NUMBER_OF_PIDS',
  INVALID_ECDN_SETTINGS = 'INVALID_ECDN_SETTINGS',
  INVALID_PRIMARY_LANGUAGE_CONFIGURATION_PROVIDED = 'INVALID_PRIMARY_LANGUAGE_CONFIGURATION_PROVIDED',
  INVALID_VIDEO_CONFIGURATION_PROVIDED = 'INVALID_VIDEO_CONFIGURATION_PROVIDED',
  LANGUAGE_LINKED_WITH_PRESENTATIONS = 'LANGUAGE_LINKED_WITH_PRESENTATIONS',
  LANGUAGE_NOT_SUPPORTED = 'LANGUAGE_NOT_SUPPORTED',
  MORE_THAN_ONE_INGEST_FIELD_PROVIDED = 'MORE_THAN_ONE_INGEST_FIELD_PROVIDED',
  NO_ACTIVE_ECDN_SETTINGS = 'NO_ACTIVE_ECDN_SETTINGS',
  PRIMARY_LANGUAGE_NOT_PROVIDED = 'PRIMARY_LANGUAGE_NOT_PROVIDED',
  THEME_NOT_FOUND = 'THEME_NOT_FOUND',
  TOO_MANY_PRIMARY_LANGUAGES_PROVIDED = 'TOO_MANY_PRIMARY_LANGUAGES_PROVIDED',
  TRANSCODING_PROFILE_NOT_FOUND = 'TRANSCODING_PROFILE_NOT_FOUND',
  TRANSCODING_PROFILE_UPDATE_NOT_ALLOWED = 'TRANSCODING_PROFILE_UPDATE_NOT_ALLOWED',
  VIDEO_MANAGER_CHANNELS_NOT_PROVIDED = 'VIDEO_MANAGER_CHANNELS_NOT_PROVIDED',
  VIDEO_MANAGER_NOT_SPECIFIED = 'VIDEO_MANAGER_NOT_SPECIFIED',
  VOD_AUTOMATION_REQUIRES_VIDEO_MANAGER = 'VOD_AUTOMATION_REQUIRES_VIDEO_MANAGER',
  WEBCAST_NOT_IN_PRELIVE_STATE = 'WEBCAST_NOT_IN_PRELIVE_STATE',
}

export type UpdateWebcastResult = UpdateWebcastProblem | UpdateWebcastSuccess | ValidationErrors;

/** Webcast has been successfully updated */
export type UpdateWebcastSuccess = {
  __typename?: 'UpdateWebcastSuccess';
  webcast: Webcast;
};

export type UploadLink = {
  __typename?: 'UploadLink';
  /**
   * Security token that needs to passed in HTTP header when uploading the presentation:
   *
   * Authorization: token <TOKEN>
   */
  token: Scalars['String']['output'];
  /** Upload URL */
  url: Scalars['String']['output'];
};

export type UpsertVodChapterInput = {
  /** If non-null, corresponding chapter is updated and its assets (thumbnail) are preserved. */
  id?: InputMaybe<Scalars['ID']['input']>;
  offsetInMs: Scalars['Long']['input'];
  titles: Array<LocalizedTextInput>;
};

export type UpsertVodChaptersInput = {
  chapters: Array<UpsertVodChapterInput>;
  webcastId: Scalars['ID']['input'];
};

export type UpsertVodChaptersProblem = {
  __typename?: 'UpsertVodChaptersProblem';
  code: UpsertVodChaptersProblemCode;
};

export enum UpsertVodChaptersProblemCode {
  FORBIDDEN_FOR_CURRENT_WEBCAST_STATE = 'FORBIDDEN_FOR_CURRENT_WEBCAST_STATE',
  LSPRO_NOT_FOUND = 'LSPRO_NOT_FOUND',
  TITLE_FOR_PRIMARY_LANGUAGE_NOT_CONFIGURED = 'TITLE_FOR_PRIMARY_LANGUAGE_NOT_CONFIGURED',
  WEBCAST_NOT_FOUND = 'WEBCAST_NOT_FOUND',
}

export type UpsertVodChaptersProblemDuplicatedId = {
  __typename?: 'UpsertVodChaptersProblemDuplicatedId';
  id: Scalars['ID']['output'];
};

export type UpsertVodChaptersProblemDuplicatedOffsetValue = {
  __typename?: 'UpsertVodChaptersProblemDuplicatedOffsetValue';
  offsetInMs: Scalars['Long']['output'];
};

export type UpsertVodChaptersProblemLanguagesNotSupported = {
  __typename?: 'UpsertVodChaptersProblemLanguagesNotSupported';
  languages: Array<Scalars['String']['output']>;
};

export type UpsertVodChaptersResult =
  | UpsertVodChaptersProblem
  | UpsertVodChaptersProblemDuplicatedId
  | UpsertVodChaptersProblemDuplicatedOffsetValue
  | UpsertVodChaptersProblemLanguagesNotSupported
  | UpsertVodChaptersSuccess;

export type UpsertVodChaptersSuccess = {
  __typename?: 'UpsertVodChaptersSuccess';
  chapters: Array<VodChapter>;
};

export type UrlInput = {
  url?: InputMaybe<Scalars['Url']['input']>;
};

export type User = {
  __typename?: 'User';
  email: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  invitedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  roles: Array<Role>;
  status: UserStatus;
};

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  DELETED = 'DELETED',
  DISABLED = 'DISABLED',
  INVITED = 'INVITED',
}

export type ValidationError = {
  __typename?: 'ValidationError';
  code: ValidationErrorCode;
  field: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export enum ValidationErrorCode {
  PATTERN = 'Pattern',
  POSITIVE = 'Positive',
  POSITIVEORZERO = 'PositiveOrZero',
  RANGE = 'Range',
  SIZE = 'Size',
  UNKNOWN = 'Unknown',
}

export type ValidationErrors = {
  __typename?: 'ValidationErrors';
  errors?: Maybe<Array<Maybe<ValidationError>>>;
};

export type Video = {
  __typename?: 'Video';
  channelId: Scalars['ID']['output'];
  createdDate: Scalars['DateTime']['output'];
  duration: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  playback: PlaybackResult;
  securityPolicy: VideoManagerSecurityPolicyResult;
  thumbnail?: Maybe<Scalars['Url']['output']>;
  title: Scalars['String']['output'];
};

/**
 * GraphQL Cursor Connections Specification:
 *
 * https://relay.dev/graphql/connections.htm
 */
export type VideoConnection = {
  __typename?: 'VideoConnection';
  edges: Array<VideoEdge>;
  pageInfo: PageInfo;
};

export type VideoEdge = {
  __typename?: 'VideoEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Video;
};

export type VideoInput = {
  reference?: InputMaybe<VideoReferenceInput>;
};

export type VideoManager = {
  __typename?: 'VideoManager';
  channels?: Maybe<Array<Channel>>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VideoManagerChannel = {
  __typename?: 'VideoManagerChannel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VideoManagerChannelInput = {
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};

export type VideoManagerLink = {
  __typename?: 'VideoManagerLink';
  autoSwitchToVod?: Maybe<Scalars['Boolean']['output']>;
  channels?: Maybe<Array<VideoManagerChannel>>;
  enabled: Scalars['Boolean']['output'];
  uploadSubtitles?: Maybe<Scalars['Boolean']['output']>;
  videoManagerId?: Maybe<Scalars['ID']['output']>;
};

export type VideoManagerLinkInput = {
  autoSwitchToVod?: InputMaybe<Scalars['Boolean']['input']>;
  channels?: InputMaybe<Array<VideoManagerChannelInput>>;
  enabled: Scalars['Boolean']['input'];
  uploadSubtitles?: Scalars['Boolean']['input'];
  videoManagerId?: InputMaybe<Scalars['ID']['input']>;
};

export type VideoManagerSecurityPolicy = {
  __typename?: 'VideoManagerSecurityPolicy';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VideoManagerSecurityPolicyResult =
  | NoVideoManagerSecurityPolicy
  | NotSupportedForThisQuery
  | VideoManagerSecurityPolicy;

export type VideoReference = {
  __typename?: 'VideoReference';
  channelId: Scalars['ID']['output'];
  videoId: Scalars['ID']['output'];
  videoManagerId?: Maybe<Scalars['ID']['output']>;
};

export type VideoReferenceInput = {
  channelId: Scalars['ID']['input'];
  videoId: Scalars['ID']['input'];
  videoManagerId?: InputMaybe<Scalars['ID']['input']>;
};

export type VideoSearchProblem = {
  __typename?: 'VideoSearchProblem';
  code: VideoSearchProblemCode;
};

export enum VideoSearchProblemCode {
  VMPRO_LINK_MISSING = 'VMPRO_LINK_MISSING',
}

export type VideoSearchResult = ValidationErrors | VideoConnection | VideoSearchProblem;

export type VideoSources = {
  __typename?: 'VideoSources';
  progressive: Array<ProgressiveVideoSource>;
};

export enum ViewerAccessFilter {
  PUBLIC = 'PUBLIC',
}

export enum ViewerSourceMode {
  /**
   * The system will select the primary streaming source if it is available and healthy; otherwise it will
   * automatically use backup.
   */
  AUTO = 'AUTO',
  /** Force the use of the backup streaming source for viewers */
  FORCE_BACKUP = 'FORCE_BACKUP',
  /** Force the use of the primary streaming source for viewers */
  FORCE_PRIMARY = 'FORCE_PRIMARY',
}

export type VodChapter = {
  __typename?: 'VodChapter';
  id: Scalars['ID']['output'];
  offsetInMs: Scalars['Long']['output'];
  thumbnail: Asset;
  thumbnailUploadLink?: Maybe<UploadLink>;
  titles: Array<LocalizedText>;
};

export type VodSlideMarker = {
  __typename?: 'VodSlideMarker';
  groupId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  offsetInMs: Scalars['Long']['output'];
};

export type VodStream = {
  __typename?: 'VodStream';
  /** Vod stream metadata */
  metadata?: Maybe<StreamMetadata>;
  /** Offset for the VOD video start time */
  offsetInSeconds: Scalars['Int']['output'];
  /** Parameters for selecting the VOD video */
  reference?: Maybe<VideoReference>;
  videoVodManifestUrl?: Maybe<Scalars['Url']['output']>;
};

export type VodStreaming = {
  __typename?: 'VodStreaming';
  chapters: Array<VodChapter>;
  enabled: Scalars['Boolean']['output'];
  slideMarkers: Array<VodSlideMarker>;
  streams?: Maybe<Array<VodStream>>;
};

export type WatermarkingFeature = LiveStreamProFeature & {
  __typename?: 'WatermarkingFeature';
  enabled: Scalars['Boolean']['output'];
};

export type Webcast = {
  __typename?: 'Webcast';
  /** Account (customer) ID */
  accountId: Scalars['String']['output'];
  /** Additional languages */
  additionalLangs: Array<Language>;
  /**
   * Deprecated. Use `additionalLangs` instead
   * @deprecated No longer supported
   */
  additionalLanguages: Array<Scalars['String']['output']>;
  /** Webcast analytics */
  analytics?: Maybe<Analytics>;
  /** When true, the webcast is audio only (no video). If true, any transcoding profile settings are ignored */
  audioOnly: Scalars['Boolean']['output'];
  /** Chat details connected with the webcast */
  chat?: Maybe<Chat>;
  /** Webcast media content for all languages */
  contents: Array<WebcastContent>;
  /** Cover image url */
  coverImageUrl?: Maybe<Scalars['String']['output']>;
  /** Webcast creation date and time (ISO 8601) */
  createdDate: Scalars['DateTime']['output'];
  /** Creator of the event. In case of copied event, the user who initiated copying. */
  creator: User;
  /** Planned duration of the webcast event in minutes. Value 0 means that planned duration is not known */
  durationInMinutes: Scalars['Int']['output'];
  /** E-Cdn config */
  ecdnSettings?: Maybe<ECdnSettings>;
  /** Webcast event permission */
  eventPermission: EventPermission;
  /** Does not display planned start and duration in the viewer application */
  hideWebcastScheduleInViewer: Scalars['Boolean']['output'];
  /** Webcast ID */
  id: Scalars['ID']['output'];
  /** LiveStream Pro id */
  lsproId: Scalars['String']['output'];
  /** event name */
  name: Scalars['String']['output'];
  /** If a webcast was copied, id of the original */
  originalWebcastId?: Maybe<Scalars['ID']['output']>;
  /** Planned start date and time (ISO 8601) */
  plannedStartAt: Scalars['DateTime']['output'];
  /** Presentations associated with given webcast */
  presentations: Array<Presentation>;
  /** Primary language */
  primaryLang: Language;
  /**
   * Deprecated. Use `primaryLang` instead
   * @deprecated No longer supported
   */
  primaryLanguage: Scalars['String']['output'];
  /** Recording settings */
  recordingSettings?: Maybe<RecordingSettings>;
  /** Security policies */
  securityPolicies: Array<SecurityPolicy>;
  /** Sharing link */
  sharingLink?: Maybe<SharingLink>;
  /**
   * Sharing url
   * @deprecated Use sharingLink instead
   */
  sharingUrl?: Maybe<Scalars['String']['output']>;
  /** Speakers for the webcast (max 6) */
  speakers: Array<Speaker>;
  /** State */
  state?: Maybe<State>;
  /** Streaming details connected with the webcast */
  streaming?: Maybe<Streaming>;
  /** Subtitles settings */
  subtitleSettings?: Maybe<SubtitleSettings>;
  /** Theme for the event */
  themeId?: Maybe<Scalars['String']['output']>;
};

/**
 * GraphQL Cursor Connections Specification:
 *
 * https://relay.dev/graphql/connections.htm
 */
export type WebcastConnection = {
  __typename?: 'WebcastConnection';
  edges: Array<WebcastEdge>;
  pageInfo: PageInfo;
};

export type WebcastContent = {
  __typename?: 'WebcastContent';
  language: Scalars['String']['output'];
  live: WebcastLiveContent;
  postLive: WebcastPostLiveContent;
  preLive: WebcastPreLiveContent;
  title?: Maybe<Scalars['String']['output']>;
};

export type WebcastContentInput = {
  language?: InputMaybe<Scalars['String']['input']>;
  live?: InputMaybe<WebcastLiveContentInput>;
  postLive?: InputMaybe<WebcastPostLiveContentInput>;
  preLive?: InputMaybe<WebcastPreLiveContentInput>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type WebcastEdge = {
  __typename?: 'WebcastEdge';
  cursor?: Maybe<Scalars['String']['output']>;
  node: Webcast;
};

export type WebcastFilters = {
  plannedStartAt?: InputMaybe<DateRange>;
  states?: InputMaybe<Array<StateFilter>>;
  users?: InputMaybe<Array<Scalars['ID']['input']>>;
  viewerAccess?: InputMaybe<ViewerAccessFilter>;
};

export type WebcastLiveContent = {
  __typename?: 'WebcastLiveContent';
  coverImage?: Maybe<Asset>;
  description?: Maybe<Scalars['String']['output']>;
};

export type WebcastLiveContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export enum WebcastOrder {
  CREATOR_ID_ASC = 'CREATOR_ID_ASC',
  CREATOR_ID_DESC = 'CREATOR_ID_DESC',
  PLANNED_AT_ASC = 'PLANNED_AT_ASC',
  PLANNED_AT_DESC = 'PLANNED_AT_DESC',
  STATE_ASC = 'STATE_ASC',
  STATE_DESC = 'STATE_DESC',
  /** By default list is sorted by planned start date (newest to oldest) and shows events in LIVE and LIVE_TEST first */
  STATE_THEN_PLANNED_AT_DESC = 'STATE_THEN_PLANNED_AT_DESC',
}

export type WebcastPostLiveContent = {
  __typename?: 'WebcastPostLiveContent';
  coverImage?: Maybe<Asset>;
  description?: Maybe<Scalars['String']['output']>;
  video?: Maybe<VideoReference>;
  videoVodManifestUrl?: Maybe<Scalars['Url']['output']>;
};

export type WebcastPostLiveContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<VideoInput>;
  videoVodManifestUrl?: InputMaybe<UrlInput>;
};

export type WebcastPreLiveContent = {
  __typename?: 'WebcastPreLiveContent';
  coverImage?: Maybe<Asset>;
  description?: Maybe<Scalars['String']['output']>;
  video?: Maybe<VideoReference>;
  videoVodManifestUrl?: Maybe<Scalars['Url']['output']>;
};

export type WebcastPreLiveContentInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  video?: InputMaybe<VideoInput>;
  videoVodManifestUrl?: InputMaybe<UrlInput>;
};

export type GetWebcastForOperatorQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetWebcastForOperatorQuery = {
  __typename?: 'Query';
  webcast: {
    __typename?: 'Webcast';
    id: string;
    name: string;
    state?: State | null | undefined;
    plannedStartAt: string;
    audioOnly: boolean;
    primaryLang:
      | { __typename?: 'CustomLanguage'; code: string; name: string }
      | { __typename?: 'StandardLanguage'; code: string };
    additionalLangs: Array<
      { __typename?: 'CustomLanguage'; code: string; name: string } | { __typename?: 'StandardLanguage'; code: string }
    >;
    subtitleSettings?: { __typename?: 'SubtitleSettings'; aiLiveTranscriptGeneration: boolean } | null | undefined;
    sharingLink?:
      | { __typename?: 'SharingLink'; sharingUrl: string; token?: string | null | undefined }
      | null
      | undefined;
    contents: Array<{
      __typename?: 'WebcastContent';
      language: string;
      title?: string | null | undefined;
      preLive: { __typename?: 'WebcastPreLiveContent'; description?: string | null | undefined };
      live: { __typename?: 'WebcastLiveContent'; description?: string | null | undefined };
      postLive: { __typename?: 'WebcastPostLiveContent'; description?: string | null | undefined };
    }>;
    speakers: Array<{
      __typename?: 'Speaker';
      id: string;
      name: string;
      position: string;
      picture: { __typename?: 'Asset'; downloadLink?: string | null | undefined };
    }>;
    streaming?:
      | {
          __typename?: 'Streaming';
          live?: { __typename?: 'LiveStreaming'; ingestProtocol: IngestProtocol } | null | undefined;
        }
      | null
      | undefined;
    chat?:
      | {
          __typename?: 'Chat';
          applicationId: string;
          channelUrl: string;
          moderatorIds: Array<string | null | undefined>;
          apiHost: string;
          wsHost: string;
          settings:
            | { __typename?: 'AnonymousChatSettings'; type: ChatType }
            | { __typename?: 'ModeratedChatSettings'; type: ChatType; useProvidedUsername: boolean }
            | { __typename?: 'UnmoderatedChatSettings'; type: ChatType; useProvidedUsername: boolean };
        }
      | null
      | undefined;
  };
  currentUser?: { __typename?: 'CurrentUser'; id: string } | null | undefined;
};

export type GetPresentationsQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetPresentationsQuery = {
  __typename?: 'Query';
  webcast: {
    __typename?: 'Webcast';
    id: string;
    presentations: Array<{
      __typename?: 'Presentation';
      id: string;
      groupId: string;
      language: string;
      slides?:
        | Array<{ __typename?: 'PresentationSlide'; index: number; thumbnailDownloadUrl: string }>
        | null
        | undefined;
    }>;
  };
};

export type GetSecurityPoliciesQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetSecurityPoliciesQuery = {
  __typename?: 'Query';
  webcast: {
    __typename?: 'Webcast';
    id: string;
    securityPolicies: Array<
      | { __typename?: 'AccessCodePolicy'; enabled: boolean; accessCode: string }
      | { __typename?: 'EmailRegistrationPolicy' }
      | { __typename?: 'EmailWhitelistPolicy' }
      | { __typename?: 'ReferrerProtectionPolicy' }
      | { __typename?: 'SingleSignOnPolicy' }
      | { __typename?: 'TokenProtectionPolicy' }
    >;
  };
};

export type GetSlidesHistoryQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetSlidesHistoryQuery = {
  __typename?: 'Query';
  session:
    | { __typename?: 'GetSessionProblem'; code?: GetSessionProblemCode | null | undefined }
    | {
        __typename?: 'GetSessionSuccess';
        pushedSlides: Array<{ __typename?: 'PushedSlide'; groupId: string; index: number }>;
      };
};

export type GetHighlightedSpeakersQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetHighlightedSpeakersQuery = {
  __typename?: 'Query';
  session:
    | { __typename?: 'GetSessionProblem'; code?: GetSessionProblemCode | null | undefined }
    | {
        __typename?: 'GetSessionSuccess';
        highlightedSpeakers: Array<{ __typename?: 'HighlightedSpeakers'; speakerIds: Array<string> }>;
      };
};

export type SetActiveSpeakersMutationVariables = Exact<{
  input: SetActiveSpeakersInput;
}>;

export type SetActiveSpeakersMutation = {
  __typename?: 'Mutation';
  setActiveSpeakers:
    | { __typename?: 'SetActiveSpeakersProblem'; code: SetActiveSpeakersProblemCode }
    | { __typename?: 'SetActiveSpeakersSuccess'; activeSpeakerIds: Array<string> };
};

export type GetEventStartDateQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetEventStartDateQuery = {
  __typename?: 'Query';
  session:
    | { __typename?: 'GetSessionProblem'; code?: GetSessionProblemCode | null | undefined }
    | { __typename?: 'GetSessionSuccess'; startDate: string; endDate?: string | null | undefined };
};

export type GetLsproSettingsForOperatorQueryVariables = Exact<{
  lsproId: Scalars['ID']['input'];
}>;

export type GetLsproSettingsForOperatorQuery = {
  __typename?: 'Query';
  lsproSettings?:
    | {
        __typename?: 'LiveStreamProSettings';
        lsproId: string;
        eventStartVerificationPolicy: EventStartVerificationPolicy;
      }
    | null
    | undefined;
};

export type PollForStreamInfoQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type PollForStreamInfoQuery = {
  __typename?: 'Query';
  webcast: {
    __typename?: 'Webcast';
    id: string;
    streaming?:
      | {
          __typename?: 'Streaming';
          live?:
            | {
                __typename?: 'LiveStreaming';
                ingestProtocol: IngestProtocol;
                parameters:
                  | { __typename?: 'RtmpLiveStreamingParameters'; authenticationEnabled: boolean }
                  | { __typename?: 'SrtLiveStreamingParameters' };
                streams: Array<{
                  __typename?: 'Stream';
                  viewerSourceMode: ViewerSourceMode;
                  metadata?: { __typename?: 'StreamMetadata'; language?: string | null | undefined } | null | undefined;
                  playback: {
                    __typename?: 'Playback';
                    primaryUrl: string;
                    backupUrl?: string | null | undefined;
                    token: string;
                  };
                  primaryStatus: {
                    __typename?: 'StreamStatus';
                    streamState: StreamState;
                    playbackState: PlaybackState;
                  };
                  backupStatus: { __typename?: 'StreamStatus'; streamState: StreamState; playbackState: PlaybackState };
                  ingest: {
                    __typename?: 'Ingest';
                    primaryServer: string;
                    backupServer: string;
                    streamName: string;
                    username: string;
                    password: string;
                  };
                  aiLiveTranscriptEditorSettings?:
                    | {
                        __typename?: 'AiLiveTranscriptEditorSettings';
                        primary?:
                          | { __typename?: 'AiLiveTranscriptEditor'; editorUrl: string; accessPin: string }
                          | null
                          | undefined;
                        backup?:
                          | { __typename?: 'AiLiveTranscriptEditor'; editorUrl: string; accessPin: string }
                          | null
                          | undefined;
                      }
                    | null
                    | undefined;
                }>;
              }
            | null
            | undefined;
        }
      | null
      | undefined;
    primaryLang:
      | { __typename?: 'CustomLanguage'; code: string; name: string }
      | { __typename?: 'StandardLanguage'; code: string };
  };
};

export type PollForViewersQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type PollForViewersQuery = {
  __typename?: 'Query';
  webcast: {
    __typename?: 'Webcast';
    analytics?:
      | {
          __typename?: 'Analytics';
          activePlaysStats: {
            __typename?: 'MetricStats';
            total: number;
            perLanguage: Array<{ __typename?: 'MetricLanguageStats'; language: string; value: number }>;
          };
        }
      | null
      | undefined;
  };
};

export type InitializeEventMutationVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type InitializeEventMutation = {
  __typename?: 'Mutation';
  initializeEvent:
    | { __typename?: 'InitializeEventProblem'; code: InitializeEventProblemCode }
    | { __typename?: 'InitializeEventSuccess' };
};

export type PushSlideMutationVariables = Exact<{
  pushSlideInput: PushSlideInput;
}>;

export type PushSlideMutation = {
  __typename?: 'Mutation';
  pushSlide:
    | { __typename?: 'PushSlideProblem'; code: PushSlideProblemCode }
    | { __typename?: 'PushSlideSuccess' }
    | { __typename?: 'ValidationErrors' };
};

export type StartEventMutationVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type StartEventMutation = {
  __typename?: 'Mutation';
  startEvent:
    | { __typename?: 'StartEventNotEnoughStreamsConnectedProblem' }
    | { __typename?: 'StartEventProblem'; code: StartEventProblemCode }
    | { __typename?: 'StartEventSuccess' };
};

export type StopEventMutationVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type StopEventMutation = {
  __typename?: 'Mutation';
  stopEvent: { __typename?: 'StopEventProblem'; code: StopEventProblemCode } | { __typename?: 'StopEventSuccess' };
};

export type PollForStateQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type PollForStateQuery = {
  __typename?: 'Query';
  webcast: { __typename?: 'Webcast'; id: string; state?: State | null | undefined };
};

export type StartLiveTestMutationVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type StartLiveTestMutation = {
  __typename?: 'Mutation';
  startLiveTest:
    | { __typename?: 'StartLiveTestProblem'; code: StartLiveTestProblemCode }
    | { __typename?: 'StartLiveTestSuccess' };
};

export type StopLiveTestMutationVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type StopLiveTestMutation = {
  __typename?: 'Mutation';
  stopLiveTest:
    | { __typename?: 'StopLiveTestProblem'; code: StopLiveTestProblemCode }
    | { __typename?: 'StopLiveTestSuccess' };
};

export type GetBlaStreamRoomQueryVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type GetBlaStreamRoomQuery = {
  __typename?: 'Query';
  blaStreamRoom: {
    __typename?: 'BlaStreamRoom';
    creationForbiddenCause?: CreationForbiddenCause | null | undefined;
    isCreationPermitted: boolean;
    connectionInfo?: { __typename?: 'BlaStreamRoomConnectionInfo'; link: string } | null | undefined;
  };
};

export type SaveBlaStreamRoomSettingsMutationVariables = Exact<{
  webcastId: Scalars['ID']['input'];
}>;

export type SaveBlaStreamRoomSettingsMutation = {
  __typename?: 'Mutation';
  saveBlaStreamRoomSettingsAsDefault:
    | { __typename?: 'SaveBlaStreamRoomSettingsAsDefaultProblem'; code: SaveBlaStreamRoomSettingsAsDefaultProblemCode }
    | { __typename?: 'SaveBlaStreamRoomSettingsAsDefaultSuccess'; _?: number | null | undefined };
};

export type UpdateStreamViewerSourceMutationVariables = Exact<{
  input: UpdateStreamViewerSourceInput;
}>;

export type UpdateStreamViewerSourceMutation = {
  __typename?: 'Mutation';
  updateStreamViewerSource:
    | { __typename?: 'UpdateStreamViewerSourceProblem'; code: UpdateStreamViewerSourceProblemCode }
    | { __typename?: 'UpdateStreamViewerSourceSuccess'; language: string; mode: ViewerSourceMode };
};

export const GetWebcastForOperatorDocument = gql`
  query GetWebcastForOperator($webcastId: ID!) {
    webcast(webcastId: $webcastId) {
      id
      name
      state
      plannedStartAt
      primaryLang {
        ... on StandardLanguage {
          code
        }
        ... on CustomLanguage {
          code
          name
        }
      }
      additionalLangs {
        ... on StandardLanguage {
          code
        }
        ... on CustomLanguage {
          code
          name
        }
      }
      subtitleSettings {
        aiLiveTranscriptGeneration
      }
      sharingLink {
        sharingUrl
        token
      }
      contents {
        language
        title
        preLive {
          description
        }
        live {
          description
        }
        postLive {
          description
        }
      }
      audioOnly
      speakers {
        id
        name
        position
        picture {
          downloadLink
        }
      }
      streaming {
        live {
          ingestProtocol
        }
      }
      chat {
        applicationId
        channelUrl
        moderatorIds
        settings {
          ... on AnonymousChatSettings {
            type
          }
          ... on ModeratedChatSettings {
            type
            useProvidedUsername
          }
          ... on UnmoderatedChatSettings {
            type
            useProvidedUsername
          }
        }
        apiHost
        wsHost
      }
    }
    currentUser {
      id
    }
  }
`;

/**
 * __useGetWebcastForOperatorQuery__
 *
 * To run a query within a React component, call `useGetWebcastForOperatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebcastForOperatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebcastForOperatorQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetWebcastForOperatorQuery(
  baseOptions: Apollo.QueryHookOptions<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables> &
    ({ variables: GetWebcastForOperatorQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables>(
    GetWebcastForOperatorDocument,
    options
  );
}
export function useGetWebcastForOperatorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables>(
    GetWebcastForOperatorDocument,
    options
  );
}
// @ts-ignore
export function useGetWebcastForOperatorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables>;
export function useGetWebcastForOperatorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables>
): Apollo.UseSuspenseQueryResult<GetWebcastForOperatorQuery | undefined, GetWebcastForOperatorQueryVariables>;
export function useGetWebcastForOperatorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetWebcastForOperatorQuery, GetWebcastForOperatorQueryVariables>(
    GetWebcastForOperatorDocument,
    options
  );
}
export type GetWebcastForOperatorQueryHookResult = ReturnType<typeof useGetWebcastForOperatorQuery>;
export type GetWebcastForOperatorLazyQueryHookResult = ReturnType<typeof useGetWebcastForOperatorLazyQuery>;
export type GetWebcastForOperatorSuspenseQueryHookResult = ReturnType<typeof useGetWebcastForOperatorSuspenseQuery>;
export type GetWebcastForOperatorQueryResult = Apollo.QueryResult<
  GetWebcastForOperatorQuery,
  GetWebcastForOperatorQueryVariables
>;
export const GetPresentationsDocument = gql`
  query GetPresentations($webcastId: ID!) {
    webcast(webcastId: $webcastId) {
      id
      presentations {
        id
        groupId
        language
        slides {
          index
          thumbnailDownloadUrl
        }
      }
    }
  }
`;

/**
 * __useGetPresentationsQuery__
 *
 * To run a query within a React component, call `useGetPresentationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresentationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresentationsQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetPresentationsQuery(
  baseOptions: Apollo.QueryHookOptions<GetPresentationsQuery, GetPresentationsQueryVariables> &
    ({ variables: GetPresentationsQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetPresentationsQuery, GetPresentationsQueryVariables>(GetPresentationsDocument, options);
}
export function useGetPresentationsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetPresentationsQuery, GetPresentationsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetPresentationsQuery, GetPresentationsQueryVariables>(GetPresentationsDocument, options);
}
// @ts-ignore
export function useGetPresentationsSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetPresentationsQuery, GetPresentationsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetPresentationsQuery, GetPresentationsQueryVariables>;
export function useGetPresentationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPresentationsQuery, GetPresentationsQueryVariables>
): Apollo.UseSuspenseQueryResult<GetPresentationsQuery | undefined, GetPresentationsQueryVariables>;
export function useGetPresentationsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetPresentationsQuery, GetPresentationsQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetPresentationsQuery, GetPresentationsQueryVariables>(
    GetPresentationsDocument,
    options
  );
}
export type GetPresentationsQueryHookResult = ReturnType<typeof useGetPresentationsQuery>;
export type GetPresentationsLazyQueryHookResult = ReturnType<typeof useGetPresentationsLazyQuery>;
export type GetPresentationsSuspenseQueryHookResult = ReturnType<typeof useGetPresentationsSuspenseQuery>;
export type GetPresentationsQueryResult = Apollo.QueryResult<GetPresentationsQuery, GetPresentationsQueryVariables>;
export const GetSecurityPoliciesDocument = gql`
  query GetSecurityPolicies($webcastId: ID!) {
    webcast(webcastId: $webcastId) {
      id
      securityPolicies {
        ... on AccessCodePolicy {
          enabled
          accessCode
        }
      }
    }
  }
`;

/**
 * __useGetSecurityPoliciesQuery__
 *
 * To run a query within a React component, call `useGetSecurityPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSecurityPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSecurityPoliciesQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetSecurityPoliciesQuery(
  baseOptions: Apollo.QueryHookOptions<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables> &
    ({ variables: GetSecurityPoliciesQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables>(
    GetSecurityPoliciesDocument,
    options
  );
}
export function useGetSecurityPoliciesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables>(
    GetSecurityPoliciesDocument,
    options
  );
}
// @ts-ignore
export function useGetSecurityPoliciesSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables>
): Apollo.UseSuspenseQueryResult<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables>;
export function useGetSecurityPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables>
): Apollo.UseSuspenseQueryResult<GetSecurityPoliciesQuery | undefined, GetSecurityPoliciesQueryVariables>;
export function useGetSecurityPoliciesSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSecurityPoliciesQuery, GetSecurityPoliciesQueryVariables>(
    GetSecurityPoliciesDocument,
    options
  );
}
export type GetSecurityPoliciesQueryHookResult = ReturnType<typeof useGetSecurityPoliciesQuery>;
export type GetSecurityPoliciesLazyQueryHookResult = ReturnType<typeof useGetSecurityPoliciesLazyQuery>;
export type GetSecurityPoliciesSuspenseQueryHookResult = ReturnType<typeof useGetSecurityPoliciesSuspenseQuery>;
export type GetSecurityPoliciesQueryResult = Apollo.QueryResult<
  GetSecurityPoliciesQuery,
  GetSecurityPoliciesQueryVariables
>;
export const GetSlidesHistoryDocument = gql`
  query GetSlidesHistory($webcastId: ID!) {
    session(webcastId: $webcastId) {
      ... on GetSessionSuccess {
        pushedSlides {
          groupId
          index
        }
      }
      ... on GetSessionProblem {
        code
      }
    }
  }
`;

/**
 * __useGetSlidesHistoryQuery__
 *
 * To run a query within a React component, call `useGetSlidesHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSlidesHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSlidesHistoryQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetSlidesHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables> &
    ({ variables: GetSlidesHistoryQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>(GetSlidesHistoryDocument, options);
}
export function useGetSlidesHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>(GetSlidesHistoryDocument, options);
}
// @ts-ignore
export function useGetSlidesHistorySuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>
): Apollo.UseSuspenseQueryResult<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>;
export function useGetSlidesHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>
): Apollo.UseSuspenseQueryResult<GetSlidesHistoryQuery | undefined, GetSlidesHistoryQueryVariables>;
export function useGetSlidesHistorySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>(
    GetSlidesHistoryDocument,
    options
  );
}
export type GetSlidesHistoryQueryHookResult = ReturnType<typeof useGetSlidesHistoryQuery>;
export type GetSlidesHistoryLazyQueryHookResult = ReturnType<typeof useGetSlidesHistoryLazyQuery>;
export type GetSlidesHistorySuspenseQueryHookResult = ReturnType<typeof useGetSlidesHistorySuspenseQuery>;
export type GetSlidesHistoryQueryResult = Apollo.QueryResult<GetSlidesHistoryQuery, GetSlidesHistoryQueryVariables>;
export const GetHighlightedSpeakersDocument = gql`
  query GetHighlightedSpeakers($webcastId: ID!) {
    session(webcastId: $webcastId) {
      ... on GetSessionSuccess {
        highlightedSpeakers {
          speakerIds
        }
      }
      ... on GetSessionProblem {
        code
      }
    }
  }
`;

/**
 * __useGetHighlightedSpeakersQuery__
 *
 * To run a query within a React component, call `useGetHighlightedSpeakersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHighlightedSpeakersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHighlightedSpeakersQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetHighlightedSpeakersQuery(
  baseOptions: Apollo.QueryHookOptions<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables> &
    ({ variables: GetHighlightedSpeakersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables>(
    GetHighlightedSpeakersDocument,
    options
  );
}
export function useGetHighlightedSpeakersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables>(
    GetHighlightedSpeakersDocument,
    options
  );
}
// @ts-ignore
export function useGetHighlightedSpeakersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables>
): Apollo.UseSuspenseQueryResult<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables>;
export function useGetHighlightedSpeakersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables>
): Apollo.UseSuspenseQueryResult<GetHighlightedSpeakersQuery | undefined, GetHighlightedSpeakersQueryVariables>;
export function useGetHighlightedSpeakersSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetHighlightedSpeakersQuery, GetHighlightedSpeakersQueryVariables>(
    GetHighlightedSpeakersDocument,
    options
  );
}
export type GetHighlightedSpeakersQueryHookResult = ReturnType<typeof useGetHighlightedSpeakersQuery>;
export type GetHighlightedSpeakersLazyQueryHookResult = ReturnType<typeof useGetHighlightedSpeakersLazyQuery>;
export type GetHighlightedSpeakersSuspenseQueryHookResult = ReturnType<typeof useGetHighlightedSpeakersSuspenseQuery>;
export type GetHighlightedSpeakersQueryResult = Apollo.QueryResult<
  GetHighlightedSpeakersQuery,
  GetHighlightedSpeakersQueryVariables
>;
export const SetActiveSpeakersDocument = gql`
  mutation SetActiveSpeakers($input: SetActiveSpeakersInput!) {
    setActiveSpeakers(input: $input) {
      ... on SetActiveSpeakersSuccess {
        activeSpeakerIds
      }
      ... on SetActiveSpeakersProblem {
        code
      }
    }
  }
`;
export type SetActiveSpeakersMutationFn = Apollo.MutationFunction<
  SetActiveSpeakersMutation,
  SetActiveSpeakersMutationVariables
>;

/**
 * __useSetActiveSpeakersMutation__
 *
 * To run a mutation, you first call `useSetActiveSpeakersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetActiveSpeakersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setActiveSpeakersMutation, { data, loading, error }] = useSetActiveSpeakersMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetActiveSpeakersMutation(
  baseOptions?: Apollo.MutationHookOptions<SetActiveSpeakersMutation, SetActiveSpeakersMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SetActiveSpeakersMutation, SetActiveSpeakersMutationVariables>(
    SetActiveSpeakersDocument,
    options
  );
}
export type SetActiveSpeakersMutationHookResult = ReturnType<typeof useSetActiveSpeakersMutation>;
export type SetActiveSpeakersMutationResult = Apollo.MutationResult<SetActiveSpeakersMutation>;
export type SetActiveSpeakersMutationOptions = Apollo.BaseMutationOptions<
  SetActiveSpeakersMutation,
  SetActiveSpeakersMutationVariables
>;
export const GetEventStartDateDocument = gql`
  query GetEventStartDate($webcastId: ID!) {
    session(webcastId: $webcastId) {
      ... on GetSessionSuccess {
        startDate
        endDate
      }
      ... on GetSessionProblem {
        code
      }
    }
  }
`;

/**
 * __useGetEventStartDateQuery__
 *
 * To run a query within a React component, call `useGetEventStartDateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEventStartDateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEventStartDateQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetEventStartDateQuery(
  baseOptions: Apollo.QueryHookOptions<GetEventStartDateQuery, GetEventStartDateQueryVariables> &
    ({ variables: GetEventStartDateQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetEventStartDateQuery, GetEventStartDateQueryVariables>(GetEventStartDateDocument, options);
}
export function useGetEventStartDateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetEventStartDateQuery, GetEventStartDateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetEventStartDateQuery, GetEventStartDateQueryVariables>(
    GetEventStartDateDocument,
    options
  );
}
// @ts-ignore
export function useGetEventStartDateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetEventStartDateQuery, GetEventStartDateQueryVariables>
): Apollo.UseSuspenseQueryResult<GetEventStartDateQuery, GetEventStartDateQueryVariables>;
export function useGetEventStartDateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventStartDateQuery, GetEventStartDateQueryVariables>
): Apollo.UseSuspenseQueryResult<GetEventStartDateQuery | undefined, GetEventStartDateQueryVariables>;
export function useGetEventStartDateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetEventStartDateQuery, GetEventStartDateQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetEventStartDateQuery, GetEventStartDateQueryVariables>(
    GetEventStartDateDocument,
    options
  );
}
export type GetEventStartDateQueryHookResult = ReturnType<typeof useGetEventStartDateQuery>;
export type GetEventStartDateLazyQueryHookResult = ReturnType<typeof useGetEventStartDateLazyQuery>;
export type GetEventStartDateSuspenseQueryHookResult = ReturnType<typeof useGetEventStartDateSuspenseQuery>;
export type GetEventStartDateQueryResult = Apollo.QueryResult<GetEventStartDateQuery, GetEventStartDateQueryVariables>;
export const GetLsproSettingsForOperatorDocument = gql`
  query GetLsproSettingsForOperator($lsproId: ID!) {
    lsproSettings(lsproId: $lsproId) {
      lsproId
      eventStartVerificationPolicy
    }
  }
`;

/**
 * __useGetLsproSettingsForOperatorQuery__
 *
 * To run a query within a React component, call `useGetLsproSettingsForOperatorQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLsproSettingsForOperatorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLsproSettingsForOperatorQuery({
 *   variables: {
 *      lsproId: // value for 'lsproId'
 *   },
 * });
 */
export function useGetLsproSettingsForOperatorQuery(
  baseOptions: Apollo.QueryHookOptions<GetLsproSettingsForOperatorQuery, GetLsproSettingsForOperatorQueryVariables> &
    ({ variables: GetLsproSettingsForOperatorQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetLsproSettingsForOperatorQuery, GetLsproSettingsForOperatorQueryVariables>(
    GetLsproSettingsForOperatorDocument,
    options
  );
}
export function useGetLsproSettingsForOperatorLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetLsproSettingsForOperatorQuery, GetLsproSettingsForOperatorQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetLsproSettingsForOperatorQuery, GetLsproSettingsForOperatorQueryVariables>(
    GetLsproSettingsForOperatorDocument,
    options
  );
}
// @ts-ignore
export function useGetLsproSettingsForOperatorSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<
    GetLsproSettingsForOperatorQuery,
    GetLsproSettingsForOperatorQueryVariables
  >
): Apollo.UseSuspenseQueryResult<GetLsproSettingsForOperatorQuery, GetLsproSettingsForOperatorQueryVariables>;
export function useGetLsproSettingsForOperatorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLsproSettingsForOperatorQuery, GetLsproSettingsForOperatorQueryVariables>
): Apollo.UseSuspenseQueryResult<
  GetLsproSettingsForOperatorQuery | undefined,
  GetLsproSettingsForOperatorQueryVariables
>;
export function useGetLsproSettingsForOperatorSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetLsproSettingsForOperatorQuery, GetLsproSettingsForOperatorQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetLsproSettingsForOperatorQuery, GetLsproSettingsForOperatorQueryVariables>(
    GetLsproSettingsForOperatorDocument,
    options
  );
}
export type GetLsproSettingsForOperatorQueryHookResult = ReturnType<typeof useGetLsproSettingsForOperatorQuery>;
export type GetLsproSettingsForOperatorLazyQueryHookResult = ReturnType<typeof useGetLsproSettingsForOperatorLazyQuery>;
export type GetLsproSettingsForOperatorSuspenseQueryHookResult = ReturnType<
  typeof useGetLsproSettingsForOperatorSuspenseQuery
>;
export type GetLsproSettingsForOperatorQueryResult = Apollo.QueryResult<
  GetLsproSettingsForOperatorQuery,
  GetLsproSettingsForOperatorQueryVariables
>;
export const PollForStreamInfoDocument = gql`
  query PollForStreamInfo($webcastId: ID!) {
    webcast(webcastId: $webcastId) {
      id
      streaming {
        live {
          ingestProtocol
          parameters {
            ... on RtmpLiveStreamingParameters {
              authenticationEnabled
            }
          }
          streams {
            metadata {
              language
            }
            playback {
              primaryUrl
              backupUrl
              token
            }
            primaryStatus {
              streamState
              playbackState
            }
            backupStatus {
              streamState
              playbackState
            }
            ingest {
              primaryServer
              backupServer
              streamName
              username
              password
            }
            aiLiveTranscriptEditorSettings {
              primary {
                editorUrl
                accessPin
              }
              backup {
                editorUrl
                accessPin
              }
            }
            viewerSourceMode
          }
        }
      }
      primaryLang {
        ... on StandardLanguage {
          code
        }
        ... on CustomLanguage {
          code
          name
        }
      }
    }
  }
`;

/**
 * __usePollForStreamInfoQuery__
 *
 * To run a query within a React component, call `usePollForStreamInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollForStreamInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollForStreamInfoQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function usePollForStreamInfoQuery(
  baseOptions: Apollo.QueryHookOptions<PollForStreamInfoQuery, PollForStreamInfoQueryVariables> &
    ({ variables: PollForStreamInfoQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>(PollForStreamInfoDocument, options);
}
export function usePollForStreamInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>(
    PollForStreamInfoDocument,
    options
  );
}
// @ts-ignore
export function usePollForStreamInfoSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>
): Apollo.UseSuspenseQueryResult<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>;
export function usePollForStreamInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>
): Apollo.UseSuspenseQueryResult<PollForStreamInfoQuery | undefined, PollForStreamInfoQueryVariables>;
export function usePollForStreamInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>(
    PollForStreamInfoDocument,
    options
  );
}
export type PollForStreamInfoQueryHookResult = ReturnType<typeof usePollForStreamInfoQuery>;
export type PollForStreamInfoLazyQueryHookResult = ReturnType<typeof usePollForStreamInfoLazyQuery>;
export type PollForStreamInfoSuspenseQueryHookResult = ReturnType<typeof usePollForStreamInfoSuspenseQuery>;
export type PollForStreamInfoQueryResult = Apollo.QueryResult<PollForStreamInfoQuery, PollForStreamInfoQueryVariables>;
export const PollForViewersDocument = gql`
  query PollForViewers($webcastId: ID!) {
    webcast(webcastId: $webcastId) {
      analytics {
        activePlaysStats {
          perLanguage {
            language
            value
          }
          total
        }
      }
    }
  }
`;

/**
 * __usePollForViewersQuery__
 *
 * To run a query within a React component, call `usePollForViewersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollForViewersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollForViewersQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function usePollForViewersQuery(
  baseOptions: Apollo.QueryHookOptions<PollForViewersQuery, PollForViewersQueryVariables> &
    ({ variables: PollForViewersQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PollForViewersQuery, PollForViewersQueryVariables>(PollForViewersDocument, options);
}
export function usePollForViewersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PollForViewersQuery, PollForViewersQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PollForViewersQuery, PollForViewersQueryVariables>(PollForViewersDocument, options);
}
// @ts-ignore
export function usePollForViewersSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PollForViewersQuery, PollForViewersQueryVariables>
): Apollo.UseSuspenseQueryResult<PollForViewersQuery, PollForViewersQueryVariables>;
export function usePollForViewersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollForViewersQuery, PollForViewersQueryVariables>
): Apollo.UseSuspenseQueryResult<PollForViewersQuery | undefined, PollForViewersQueryVariables>;
export function usePollForViewersSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollForViewersQuery, PollForViewersQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PollForViewersQuery, PollForViewersQueryVariables>(PollForViewersDocument, options);
}
export type PollForViewersQueryHookResult = ReturnType<typeof usePollForViewersQuery>;
export type PollForViewersLazyQueryHookResult = ReturnType<typeof usePollForViewersLazyQuery>;
export type PollForViewersSuspenseQueryHookResult = ReturnType<typeof usePollForViewersSuspenseQuery>;
export type PollForViewersQueryResult = Apollo.QueryResult<PollForViewersQuery, PollForViewersQueryVariables>;
export const InitializeEventDocument = gql`
  mutation InitializeEvent($webcastId: ID!) {
    initializeEvent(webcastId: $webcastId) {
      ... on InitializeEventProblem {
        code
      }
    }
  }
`;
export type InitializeEventMutationFn = Apollo.MutationFunction<
  InitializeEventMutation,
  InitializeEventMutationVariables
>;

/**
 * __useInitializeEventMutation__
 *
 * To run a mutation, you first call `useInitializeEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeEventMutation, { data, loading, error }] = useInitializeEventMutation({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useInitializeEventMutation(
  baseOptions?: Apollo.MutationHookOptions<InitializeEventMutation, InitializeEventMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<InitializeEventMutation, InitializeEventMutationVariables>(
    InitializeEventDocument,
    options
  );
}
export type InitializeEventMutationHookResult = ReturnType<typeof useInitializeEventMutation>;
export type InitializeEventMutationResult = Apollo.MutationResult<InitializeEventMutation>;
export type InitializeEventMutationOptions = Apollo.BaseMutationOptions<
  InitializeEventMutation,
  InitializeEventMutationVariables
>;
export const PushSlideDocument = gql`
  mutation PushSlide($pushSlideInput: PushSlideInput!) {
    pushSlide(input: $pushSlideInput) {
      ... on PushSlideProblem {
        code
      }
    }
  }
`;
export type PushSlideMutationFn = Apollo.MutationFunction<PushSlideMutation, PushSlideMutationVariables>;

/**
 * __usePushSlideMutation__
 *
 * To run a mutation, you first call `usePushSlideMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushSlideMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushSlideMutation, { data, loading, error }] = usePushSlideMutation({
 *   variables: {
 *      pushSlideInput: // value for 'pushSlideInput'
 *   },
 * });
 */
export function usePushSlideMutation(
  baseOptions?: Apollo.MutationHookOptions<PushSlideMutation, PushSlideMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<PushSlideMutation, PushSlideMutationVariables>(PushSlideDocument, options);
}
export type PushSlideMutationHookResult = ReturnType<typeof usePushSlideMutation>;
export type PushSlideMutationResult = Apollo.MutationResult<PushSlideMutation>;
export type PushSlideMutationOptions = Apollo.BaseMutationOptions<PushSlideMutation, PushSlideMutationVariables>;
export const StartEventDocument = gql`
  mutation StartEvent($webcastId: ID!) {
    startEvent(webcastId: $webcastId) {
      ... on StartEventProblem {
        code
      }
    }
  }
`;
export type StartEventMutationFn = Apollo.MutationFunction<StartEventMutation, StartEventMutationVariables>;

/**
 * __useStartEventMutation__
 *
 * To run a mutation, you first call `useStartEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startEventMutation, { data, loading, error }] = useStartEventMutation({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useStartEventMutation(
  baseOptions?: Apollo.MutationHookOptions<StartEventMutation, StartEventMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartEventMutation, StartEventMutationVariables>(StartEventDocument, options);
}
export type StartEventMutationHookResult = ReturnType<typeof useStartEventMutation>;
export type StartEventMutationResult = Apollo.MutationResult<StartEventMutation>;
export type StartEventMutationOptions = Apollo.BaseMutationOptions<StartEventMutation, StartEventMutationVariables>;
export const StopEventDocument = gql`
  mutation StopEvent($webcastId: ID!) {
    stopEvent(webcastId: $webcastId) {
      ... on StopEventProblem {
        code
      }
    }
  }
`;
export type StopEventMutationFn = Apollo.MutationFunction<StopEventMutation, StopEventMutationVariables>;

/**
 * __useStopEventMutation__
 *
 * To run a mutation, you first call `useStopEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopEventMutation, { data, loading, error }] = useStopEventMutation({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useStopEventMutation(
  baseOptions?: Apollo.MutationHookOptions<StopEventMutation, StopEventMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StopEventMutation, StopEventMutationVariables>(StopEventDocument, options);
}
export type StopEventMutationHookResult = ReturnType<typeof useStopEventMutation>;
export type StopEventMutationResult = Apollo.MutationResult<StopEventMutation>;
export type StopEventMutationOptions = Apollo.BaseMutationOptions<StopEventMutation, StopEventMutationVariables>;
export const PollForStateDocument = gql`
  query PollForState($webcastId: ID!) {
    webcast(webcastId: $webcastId) {
      id
      state
    }
  }
`;

/**
 * __usePollForStateQuery__
 *
 * To run a query within a React component, call `usePollForStateQuery` and pass it any options that fit your needs.
 * When your component renders, `usePollForStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePollForStateQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function usePollForStateQuery(
  baseOptions: Apollo.QueryHookOptions<PollForStateQuery, PollForStateQueryVariables> &
    ({ variables: PollForStateQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PollForStateQuery, PollForStateQueryVariables>(PollForStateDocument, options);
}
export function usePollForStateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<PollForStateQuery, PollForStateQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PollForStateQuery, PollForStateQueryVariables>(PollForStateDocument, options);
}
// @ts-ignore
export function usePollForStateSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<PollForStateQuery, PollForStateQueryVariables>
): Apollo.UseSuspenseQueryResult<PollForStateQuery, PollForStateQueryVariables>;
export function usePollForStateSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollForStateQuery, PollForStateQueryVariables>
): Apollo.UseSuspenseQueryResult<PollForStateQuery | undefined, PollForStateQueryVariables>;
export function usePollForStateSuspenseQuery(
  baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PollForStateQuery, PollForStateQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<PollForStateQuery, PollForStateQueryVariables>(PollForStateDocument, options);
}
export type PollForStateQueryHookResult = ReturnType<typeof usePollForStateQuery>;
export type PollForStateLazyQueryHookResult = ReturnType<typeof usePollForStateLazyQuery>;
export type PollForStateSuspenseQueryHookResult = ReturnType<typeof usePollForStateSuspenseQuery>;
export type PollForStateQueryResult = Apollo.QueryResult<PollForStateQuery, PollForStateQueryVariables>;
export const StartLiveTestDocument = gql`
  mutation StartLiveTest($webcastId: ID!) {
    startLiveTest(webcastId: $webcastId) {
      ... on StartLiveTestProblem {
        code
      }
    }
  }
`;
export type StartLiveTestMutationFn = Apollo.MutationFunction<StartLiveTestMutation, StartLiveTestMutationVariables>;

/**
 * __useStartLiveTestMutation__
 *
 * To run a mutation, you first call `useStartLiveTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartLiveTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startLiveTestMutation, { data, loading, error }] = useStartLiveTestMutation({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useStartLiveTestMutation(
  baseOptions?: Apollo.MutationHookOptions<StartLiveTestMutation, StartLiveTestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StartLiveTestMutation, StartLiveTestMutationVariables>(StartLiveTestDocument, options);
}
export type StartLiveTestMutationHookResult = ReturnType<typeof useStartLiveTestMutation>;
export type StartLiveTestMutationResult = Apollo.MutationResult<StartLiveTestMutation>;
export type StartLiveTestMutationOptions = Apollo.BaseMutationOptions<
  StartLiveTestMutation,
  StartLiveTestMutationVariables
>;
export const StopLiveTestDocument = gql`
  mutation StopLiveTest($webcastId: ID!) {
    stopLiveTest(webcastId: $webcastId) {
      ... on StopLiveTestProblem {
        code
      }
    }
  }
`;
export type StopLiveTestMutationFn = Apollo.MutationFunction<StopLiveTestMutation, StopLiveTestMutationVariables>;

/**
 * __useStopLiveTestMutation__
 *
 * To run a mutation, you first call `useStopLiveTestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopLiveTestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopLiveTestMutation, { data, loading, error }] = useStopLiveTestMutation({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useStopLiveTestMutation(
  baseOptions?: Apollo.MutationHookOptions<StopLiveTestMutation, StopLiveTestMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<StopLiveTestMutation, StopLiveTestMutationVariables>(StopLiveTestDocument, options);
}
export type StopLiveTestMutationHookResult = ReturnType<typeof useStopLiveTestMutation>;
export type StopLiveTestMutationResult = Apollo.MutationResult<StopLiveTestMutation>;
export type StopLiveTestMutationOptions = Apollo.BaseMutationOptions<
  StopLiveTestMutation,
  StopLiveTestMutationVariables
>;
export const GetBlaStreamRoomDocument = gql`
  query GetBlaStreamRoom($webcastId: ID!) {
    blaStreamRoom(webcastId: $webcastId) {
      connectionInfo {
        link
      }
      creationForbiddenCause
      isCreationPermitted
    }
  }
`;

/**
 * __useGetBlaStreamRoomQuery__
 *
 * To run a query within a React component, call `useGetBlaStreamRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBlaStreamRoomQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBlaStreamRoomQuery({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useGetBlaStreamRoomQuery(
  baseOptions: Apollo.QueryHookOptions<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables> &
    ({ variables: GetBlaStreamRoomQueryVariables; skip?: boolean } | { skip: boolean })
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>(GetBlaStreamRoomDocument, options);
}
export function useGetBlaStreamRoomLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>(GetBlaStreamRoomDocument, options);
}
// @ts-ignore
export function useGetBlaStreamRoomSuspenseQuery(
  baseOptions?: Apollo.SuspenseQueryHookOptions<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>
): Apollo.UseSuspenseQueryResult<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>;
export function useGetBlaStreamRoomSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>
): Apollo.UseSuspenseQueryResult<GetBlaStreamRoomQuery | undefined, GetBlaStreamRoomQueryVariables>;
export function useGetBlaStreamRoomSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>
) {
  const options = baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>(
    GetBlaStreamRoomDocument,
    options
  );
}
export type GetBlaStreamRoomQueryHookResult = ReturnType<typeof useGetBlaStreamRoomQuery>;
export type GetBlaStreamRoomLazyQueryHookResult = ReturnType<typeof useGetBlaStreamRoomLazyQuery>;
export type GetBlaStreamRoomSuspenseQueryHookResult = ReturnType<typeof useGetBlaStreamRoomSuspenseQuery>;
export type GetBlaStreamRoomQueryResult = Apollo.QueryResult<GetBlaStreamRoomQuery, GetBlaStreamRoomQueryVariables>;
export const SaveBlaStreamRoomSettingsDocument = gql`
  mutation SaveBlaStreamRoomSettings($webcastId: ID!) {
    saveBlaStreamRoomSettingsAsDefault(webcastId: $webcastId) {
      ... on SaveBlaStreamRoomSettingsAsDefaultSuccess {
        _
      }
      ... on SaveBlaStreamRoomSettingsAsDefaultProblem {
        code
      }
    }
  }
`;
export type SaveBlaStreamRoomSettingsMutationFn = Apollo.MutationFunction<
  SaveBlaStreamRoomSettingsMutation,
  SaveBlaStreamRoomSettingsMutationVariables
>;

/**
 * __useSaveBlaStreamRoomSettingsMutation__
 *
 * To run a mutation, you first call `useSaveBlaStreamRoomSettingsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveBlaStreamRoomSettingsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveBlaStreamRoomSettingsMutation, { data, loading, error }] = useSaveBlaStreamRoomSettingsMutation({
 *   variables: {
 *      webcastId: // value for 'webcastId'
 *   },
 * });
 */
export function useSaveBlaStreamRoomSettingsMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SaveBlaStreamRoomSettingsMutation,
    SaveBlaStreamRoomSettingsMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SaveBlaStreamRoomSettingsMutation, SaveBlaStreamRoomSettingsMutationVariables>(
    SaveBlaStreamRoomSettingsDocument,
    options
  );
}
export type SaveBlaStreamRoomSettingsMutationHookResult = ReturnType<typeof useSaveBlaStreamRoomSettingsMutation>;
export type SaveBlaStreamRoomSettingsMutationResult = Apollo.MutationResult<SaveBlaStreamRoomSettingsMutation>;
export type SaveBlaStreamRoomSettingsMutationOptions = Apollo.BaseMutationOptions<
  SaveBlaStreamRoomSettingsMutation,
  SaveBlaStreamRoomSettingsMutationVariables
>;
export const UpdateStreamViewerSourceDocument = gql`
  mutation UpdateStreamViewerSource($input: UpdateStreamViewerSourceInput!) {
    updateStreamViewerSource(input: $input) {
      ... on UpdateStreamViewerSourceSuccess {
        language
        mode
      }
      ... on UpdateStreamViewerSourceProblem {
        code
      }
    }
  }
`;
export type UpdateStreamViewerSourceMutationFn = Apollo.MutationFunction<
  UpdateStreamViewerSourceMutation,
  UpdateStreamViewerSourceMutationVariables
>;

/**
 * __useUpdateStreamViewerSourceMutation__
 *
 * To run a mutation, you first call `useUpdateStreamViewerSourceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateStreamViewerSourceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateStreamViewerSourceMutation, { data, loading, error }] = useUpdateStreamViewerSourceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateStreamViewerSourceMutation(
  baseOptions?: Apollo.MutationHookOptions<UpdateStreamViewerSourceMutation, UpdateStreamViewerSourceMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<UpdateStreamViewerSourceMutation, UpdateStreamViewerSourceMutationVariables>(
    UpdateStreamViewerSourceDocument,
    options
  );
}
export type UpdateStreamViewerSourceMutationHookResult = ReturnType<typeof useUpdateStreamViewerSourceMutation>;
export type UpdateStreamViewerSourceMutationResult = Apollo.MutationResult<UpdateStreamViewerSourceMutation>;
export type UpdateStreamViewerSourceMutationOptions = Apollo.BaseMutationOptions<
  UpdateStreamViewerSourceMutation,
  UpdateStreamViewerSourceMutationVariables
>;
